webpackJsonp([2,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {'use strict';
	
	var _vue = __webpack_require__(133);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(299);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueResource = __webpack_require__(265);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _vuex = __webpack_require__(41);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _vuexI18n = __webpack_require__(132);
	
	var _vuexI18n2 = _interopRequireDefault(_vuexI18n);
	
	var _fastclick = __webpack_require__(264);
	
	var _fastclick2 = _interopRequireDefault(_fastclick);
	
	var _ECharts = __webpack_require__(248);
	
	var _ECharts2 = _interopRequireDefault(_ECharts);
	
	var _store = __webpack_require__(604);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _App = __webpack_require__(249);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _HelloFromVux = __webpack_require__(256);
	
	var _HelloFromVux2 = _interopRequireDefault(_HelloFromVux);
	
	var _Hello = __webpack_require__(255);
	
	var _Hello2 = _interopRequireDefault(_Hello);
	
	var _HomeHead = __webpack_require__(258);
	
	var _HomeHead2 = _interopRequireDefault(_HomeHead);
	
	var _HomeBody = __webpack_require__(257);
	
	var _HomeBody2 = _interopRequireDefault(_HomeBody);
	
	var _DetailHead = __webpack_require__(250);
	
	var _DetailHead2 = _interopRequireDefault(_DetailHead);
	
	var _DetailPrice = __webpack_require__(251);
	
	var _DetailPrice2 = _interopRequireDefault(_DetailPrice);
	
	var _DetailQty = __webpack_require__(252);
	
	var _DetailQty2 = _interopRequireDefault(_DetailQty);
	
	var _DetailType = __webpack_require__(254);
	
	var _DetailType2 = _interopRequireDefault(_DetailType);
	
	var _HomePay = __webpack_require__(259);
	
	var _HomePay2 = _interopRequireDefault(_HomePay);
	
	var _DetailTest = __webpack_require__(253);
	
	var _DetailTest2 = _interopRequireDefault(_DetailTest);
	
	__webpack_require__(169);
	
	__webpack_require__(178);
	
	__webpack_require__(180);
	
	__webpack_require__(190);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vueResource2.default);
	_vue2.default.use(_vuex2.default);
	_vue2.default.http.options.emulateJSON = true;
	_vue2.default.http.options.emulateHTTP = true;
	
	_vue2.default.component('chart', _ECharts2.default);
	
	var _ver = '12';
	console.warn(">>> Current Ver:" + _ver);
	
	console.log("__dirname:" + __dirname);
	
	var NotFound = { template: '<div>not-found</div>' };
	
	var routes = [{
	  path: '/hello',
	  component: _Hello2.default
	}, {
	  path: '/vux',
	  component: _HelloFromVux2.default
	}, { path: '/test', component: _DetailTest2.default }, { path: '/', component: _HomeHead2.default,
	  children: [{ path: 'pay', component: _HomePay2.default }, { path: '', component: _HomeBody2.default }]
	}, { path: '/detail', component: _DetailHead2.default,
	  children: [{ path: '', component: _DetailPrice2.default }, { path: 'qty', component: _DetailQty2.default }, { path: 'type', component: _DetailType2.default }]
	}, { path: '', redirect: '/' }, { path: '*', component: NotFound }];
	
	var router = new _vueRouter2.default({
	  mode: 'history',
	  base: '/real/gzh',
	  routes: routes
	});
	
	_fastclick2.default.attach(document.body);
	
	_vue2.default.use(_vuexI18n2.default.plugin, _store2.default);
	
	_vue2.default.i18n.set('zh-CN');
	
	new _vue2.default({
	  store: _store2.default,
	  router: router,
	  render: function render(h) {
	    return h(_App2.default);
	  }
	}).$mount('#app');
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  getCm: function getCm() {
	    console.log("get community:%s", localStorage.cm);
	    return localStorage.cm;
	  },
	  setCm: function setCm(cb) {
	    if (cb.length == 0) {
	      console.error("setCm - input cb error:%s", cb);
	      return;
	    }
	    console.log("set community:%s", cb);
	    localStorage.cm = cb;
	  },
	  delCm: function delCm() {
	    console.log("delete community");
	    delete localStorage.cm;
	  },
	  getCmType: function getCmType() {
	    console.log("get community:%s", localStorage.cm);
	    return localStorage.cmType;
	  },
	  setCmType: function setCmType(cb) {
	    if (cb.length == 0) {
	      console.error("setCm - input cb error:%s", cb);
	      return;
	    }
	    console.log("set community:%s", cb);
	    localStorage.cmType = cb;
	  },
	  delCmType: function delCmType() {
	    console.log("delete community type");
	    delete localStorage.cmType;
	  },
	  getOpenid: function getOpenid() {
	    console.log("get openid:%s", localStorage.openid);
	    return localStorage.openid;
	  },
	  setOpenid: function setOpenid(cb) {
	    if (cb.length == 0) {
	      console.error("setOpenid - input cb error:%s", cb);
	      return;
	    }
	    console.log("set openid:%s", cb);
	    localStorage.openid = cb;
	  },
	  delOpenId: function delOpenId() {
	    console.log("delete openid");
	    delete localStorage.openid;
	  },
	  getToken: function getToken() {
	    console.log("get token:%s", localStorage.token);
	    return localStorage.token;
	  },
	  setToken: function setToken(cb) {
	    if (cb.length == 0) {
	      console.error("setToken - input cb error:%s", cb);
	      return;
	    }
	    console.log("set token:%s", cb);
	    localStorage.token = cb;
	  },
	  delToken: function delToken() {
	    console.log("delete token");
	    delete localStorage.token;
	  },
	  getName: function getName() {
	    console.log("get name:%s", localStorage.name);
	    return localStorage.name;
	  },
	  setName: function setName(cb) {
	    if (cb.length == 0) {
	      console.error("setName - input cb error:%s", cb);
	      return;
	    }
	    console.log("set name:%s", cb);
	    localStorage.name = cb;
	  },
	  delName: function delName() {
	    console.log("delete name");
	    delete localStorage.name;
	  },
	  getCoins: function getCoins() {
	    console.log("get coins:%s", localStorage.coins);
	    return localStorage.coins;
	  },
	  setCoins: function setCoins(cb) {
	    if (cb.length == 0) {
	      console.error("setCoins - input cb error:%s", cb);
	      return;
	    }
	    console.log("set coins:%s", cb);
	    localStorage.coins = cb;
	  },
	  delCoins: function delCoins() {
	    console.log("delete coins");
	    delete localStorage.coins;
	  },
	  getPortrait: function getPortrait() {
	    console.log("get portrait:%s", localStorage.portrait);
	    return localStorage.portrait;
	  },
	  setPortrait: function setPortrait(cb) {
	    if (cb.length == 0) {
	      console.error("setPortrait - input cb error:%s", cb);
	      return;
	    }
	    console.log("set portrait:%s", cb);
	    localStorage.portrait = cb;
	  },
	  delPortrait: function delPortrait() {
	    console.log("delete portrait");
	    delete localStorage.portrait;
	  },
	  getLat: function getLat() {
	    console.log("get lat:%s", localStorage.lat);
	    return localStorage.lat;
	  },
	  setLat: function setLat(cb) {
	    if (cb.length == 0) {
	      console.error("setLat - input cb error:%s", cb);
	      return;
	    }
	    console.log("set lat:%s", cb);
	    localStorage.lat = cb;
	  },
	  delLat: function delLat() {
	    console.log("delete lat");
	    delete localStorage.lat;
	  },
	  getLongt: function getLongt() {
	    console.log("get longt:%s", localStorage.longt);
	    return localStorage.longt;
	  },
	  setLongt: function setLongt(cb) {
	    if (cb.length == 0) {
	      console.error("setLongt - input cb error:%s", cb);
	      return;
	    }
	    console.log("set longt:%s", cb);
	    localStorage.longt = cb;
	  },
	  delLongt: function delLongt() {
	    console.log("delete longt");
	    delete localStorage.longt;
	  },
	  login: function login(email, pass, cb) {
	    var _this = this;
	
	    cb = arguments[arguments.length - 1];
	    if (localStorage.token) {
	      if (cb) cb(true);
	      this.onChange(true);
	      return;
	    }
	    pretendRequest(email, pass, function (res) {
	      if (res.authenticated) {
	        localStorage.token = res.token;
	        if (cb) cb(true);
	        _this.onChange(true);
	      } else {
	        if (cb) cb(false);
	        _this.onChange(false);
	      }
	    });
	  },
	  logout: function logout(cb) {
	    delete localStorage.token;
	    if (cb) cb();
	    this.onChange(false);
	  },
	  loggedIn: function loggedIn() {
	    return !!localStorage.token;
	  },
	  onChange: function onChange() {}
	};
	
	
	function pretendRequest(email, pass, cb) {
	  setTimeout(function () {
	    if (email === 'joe@example.com' && pass === 'password1') {
	      cb({
	        authenticated: true,
	        token: Math.random().toString(36).substring(7)
	      });
	    } else {
	      cb({ authenticated: false });
	    }
	  }, 0);
	}

/***/ },
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(224)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  null,
	  /* template */
	  __webpack_require__(279),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(235)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(634),
	  /* template */
	  __webpack_require__(291),
	  /* scopeId */
	  "data-v-926fab74",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(234)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(609),
	  /* template */
	  __webpack_require__(290),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(236)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(611),
	  /* template */
	  __webpack_require__(292),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(228)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(612),
	  /* template */
	  __webpack_require__(283),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	/* customBlocks */
	__webpack_require__(262)
	
	
	module.exports = Component.exports


/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(230)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(613),
	  /* template */
	  __webpack_require__(286),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	/* customBlocks */
	__webpack_require__(263)
	
	
	module.exports = Component.exports


/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(214)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(614),
	  /* template */
	  __webpack_require__(269),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(615),
	  /* template */
	  __webpack_require__(284),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(233)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(616),
	  /* template */
	  __webpack_require__(289),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(617),
	  /* template */
	  __webpack_require__(267),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(238)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(618),
	  /* template */
	  __webpack_require__(294),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(213)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(620),
	  /* template */
	  __webpack_require__(268),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/vux_logo.79cbb96.png";

/***/ },
/* 212 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 213 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 214 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 215 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 216 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 217 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 218 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 219 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 220 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 221 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 222 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 223 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 224 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 225 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 226 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 227 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 228 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 229 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 230 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 231 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 232 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 233 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 234 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 235 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 236 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 237 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 238 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 239 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 240 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(222)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(607),
	  /* template */
	  __webpack_require__(277),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	/* customBlocks */
	__webpack_require__(260)
	
	
	module.exports = Component.exports


/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(225)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(608),
	  /* template */
	  __webpack_require__(280),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(217)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(610),
	  /* template */
	  __webpack_require__(272),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	/* customBlocks */
	__webpack_require__(261)
	
	
	module.exports = Component.exports


/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(212)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  null,
	  /* template */
	  __webpack_require__(266),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(216)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  null,
	  /* template */
	  __webpack_require__(271),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(229)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(619),
	  /* template */
	  __webpack_require__(285),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(226)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(621),
	  /* template */
	  __webpack_require__(281),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(237)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(622),
	  /* template */
	  __webpack_require__(293),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(218)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(623),
	  /* template */
	  __webpack_require__(273),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(223)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(624),
	  /* template */
	  __webpack_require__(278),
	  /* scopeId */
	  "data-v-3683b69e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(219)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(625),
	  /* template */
	  __webpack_require__(274),
	  /* scopeId */
	  "data-v-2ae935fb",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(215)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(626),
	  /* template */
	  __webpack_require__(270),
	  /* scopeId */
	  "data-v-1f28c930",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(221)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(627),
	  /* template */
	  __webpack_require__(276),
	  /* scopeId */
	  "data-v-34aa8450",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(227)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(628),
	  /* template */
	  __webpack_require__(282),
	  /* scopeId */
	  "data-v-50b53af8",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(231)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(629),
	  /* template */
	  __webpack_require__(287),
	  /* scopeId */
	  "data-v-7b27ea95",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(232)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(630),
	  /* template */
	  __webpack_require__(288),
	  /* scopeId */
	  "data-v-7d13442c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(239)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(631),
	  /* template */
	  __webpack_require__(295),
	  /* scopeId */
	  "data-v-e281eda4",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(220)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(632),
	  /* template */
	  __webpack_require__(275),
	  /* scopeId */
	  "data-v-327d6328",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(240)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(633),
	  /* template */
	  __webpack_require__(296),
	  /* scopeId */
	  "data-v-effafa68",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 260 */
/***/ function(module, exports) {



/***/ },
/* 261 */
/***/ function(module, exports) {



/***/ },
/* 262 */
/***/ function(module, exports) {



/***/ },
/* 263 */
/***/ function(module, exports) {



/***/ },
/* 264 */,
/* 265 */,
/* 266 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "vux-label-desc"
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ },
/* 267 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vux-tab-item",
	    class: [_vm.currentSelected ? _vm.activeClass : '', {
	      'vux-tab-selected': _vm.currentSelected,
	      'vux-tab-disabled': _vm.disabled
	    }],
	    style: (_vm.style),
	    on: {
	      "click": _vm.onItemClick
	    }
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ },
/* 268 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.currentValue),
	      expression: "currentValue"
	    }],
	    staticClass: "weui_dialog_alert fix_ios_fixed",
	    on: {
	      "touchmove": _vm.onTouchMove
	    }
	  }, [_c('transition', {
	    attrs: {
	      "name": "vux-mask"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.currentValue),
	      expression: "currentValue"
	    }],
	    staticClass: "weui_mask",
	    on: {
	      "click": function($event) {
	        _vm.hideOnBlur && (_vm.currentValue = false)
	      }
	    }
	  })]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.currentValue),
	      expression: "currentValue"
	    }],
	    staticStyle: {
	      "display": "none"
	    },
	    domProps: {
	      "value": _vm._s(_vm.currentValue)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.currentValue = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "vux-dialog"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.currentValue),
	      expression: "currentValue"
	    }],
	    staticClass: "weui_dialog"
	  }, [_vm._t("default")], 2)])], 1)
	},staticRenderFns: []}

/***/ },
/* 269 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ },
/* 270 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('main-layout', [_c('div', {
	    staticClass: "echarts"
	  }, [_c('chart', {
	    ref: "bar",
	    attrs: {
	      "options": _vm.bar3,
	      "theme": "ovilia-green",
	      "auto-resize": ""
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ },
/* 271 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "weui_tab"
	  }, [_vm._t("header"), _vm._v(" "), _c('div', {
	    ref: "viewBoxBody",
	    staticClass: "weui_tab_bd vux-fix-safari-overflow-scrolling"
	  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("bottom")], 2)
	},staticRenderFns: []}

/***/ },
/* 272 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('x-dialog', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.showValue),
	      expression: "showValue"
	    }],
	    staticClass: "weui_dialog_confirm",
	    attrs: {
	      "mask-transition": _vm.maskTransition,
	      "dialog-transition": _vm.dialogTransition,
	      "hide-on-blur": _vm.hideOnBlur
	    },
	    domProps: {
	      "value": (_vm.showValue)
	    },
	    on: {
	      "on-hide": function($event) {
	        _vm.$emit('on-hide')
	      },
	      "on-show": function($event) {
	        _vm.$emit('on-show')
	      },
	      "input": function($event) {
	        _vm.showValue = $event
	      }
	    }
	  }, [_c('div', {
	    staticClass: "weui_dialog_hd"
	  }, [_c('strong', {
	    staticClass: "weui_dialog_title"
	  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
	    staticClass: "weui_dialog_bd"
	  }, [_vm._t("default", [_c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.content)
	    }
	  })])], 2), _vm._v(" "), _c('div', {
	    staticClass: "weui_dialog_ft"
	  }, [_c('a', {
	    staticClass: "weui_btn_dialog default",
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": _vm.onCancel
	    }
	  }, [_vm._v(_vm._s(_vm.cancelText || _vm.$t('cancel_text')))]), _vm._v(" "), _c('a', {
	    staticClass: "weui_btn_dialog primary",
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": _vm.onConfirm
	    }
	  }, [_vm._v(_vm._s(_vm.confirmText || _vm.$t('confirm_text')))])])])], 1)
	},staticRenderFns: []}

/***/ },
/* 273 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "height": "100%"
	    }
	  }, [_c('view-box', {
	    ref: "viewBox"
	  }, [_c('transition', {
	    attrs: {
	      "name": "fade",
	      "mode": "out-in"
	    }
	  }, [_c('router-view')], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ },
/* 274 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "echarts"
	  }, [_c('chart', {
	    ref: "line",
	    attrs: {
	      "options": _vm.line
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "parent"
	  }, [(_vm.show1) ? _c('div', [_c('loading', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.show1),
	      expression: "show1"
	    }],
	    attrs: {
	      "text": _vm.text1
	    },
	    domProps: {
	      "value": (_vm.show1)
	    },
	    on: {
	      "input": function($event) {
	        _vm.show1 = $event
	      }
	    }
	  })], 1) : _c('div', [_c('card', [_c('div', {
	    staticClass: "card-demo-flex card-demo-content01",
	    slot: "content"
	  }, [_c('div', {
	    staticClass: "vux-1px-l vux-1px-r"
	  }, [_c('p', {
	    staticClass: "center-portrait"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.portrait
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "vux-1px-r"
	  }, [_c('span', [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.coins) + " 钢蹦\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "vux-1px-r"
	  }), _vm._v(" "), _c('div', [_c('p', {
	    staticClass: "center-coin",
	    attrs: {
	      "alt": "充值"
	    },
	    on: {
	      "click": _vm.regWxPay
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(210)
	    }
	  })])])])]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": _vm.transitionName
	    }
	  }, [_c('router-view', {
	    staticClass: "child-view"
	  })], 1)], 1)])
	},staticRenderFns: []}

/***/ },
/* 276 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('tab', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.index),
	      expression: "index"
	    }],
	    attrs: {
	      "line-width": 2,
	      "active-color": "#fc378c"
	    },
	    domProps: {
	      "value": (_vm.index)
	    },
	    on: {
	      "input": function($event) {
	        _vm.index = $event
	      }
	    }
	  }, _vm._l((_vm.list2), function(item) {
	    return _c('tab-item', {
	      staticClass: "vux-center",
	      attrs: {
	        "selected": _vm.demo2 === item
	      },
	      on: {
	        "click": function($event) {
	          _vm.demo2 = item
	        },
	        "on-item-click": function($event) {
	          _vm.barHandler(item)
	        }
	      }
	    }, [_vm._v(_vm._s(item))])
	  })), _vm._v(" "), _c('loading', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.show1),
	      expression: "show1"
	    }],
	    attrs: {
	      "text": _vm.text1
	    },
	    domProps: {
	      "value": (_vm.show1)
	    },
	    on: {
	      "input": function($event) {
	        _vm.show1 = $event
	      }
	    }
	  }), _vm._v(" "), _c('swiper', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.index),
	      expression: "index"
	    }],
	    attrs: {
	      "height": "500px",
	      "show-dots": false
	    },
	    domProps: {
	      "value": (_vm.index)
	    },
	    on: {
	      "input": function($event) {
	        _vm.index = $event
	      }
	    }
	  }, _vm._l((_vm.list2), function(item) {
	    return _c('swiper-item', [(item === '成交价格') ? _c('div', [_c('div', {
	      staticClass: "tab-swiper vux-center"
	    }, [_c('div', {
	      attrs: {
	        "id": "dealQty"
	      }
	    })])]) : (item === '成交量') ? _c('div', [_c('div', {
	      staticClass: "tab-swiper vux-center"
	    }, [_c('div', {
	      attrs: {
	        "id": "dealPrice"
	      }
	    })])]) : (item === '户型分布') ? _c('div', [_c('div', {
	      staticClass: "tab-swiper vux-center"
	    }, [_c('div', {
	      attrs: {
	        "id": "dealType"
	      }
	    })])]) : _c('div', [_c('div', {
	      staticClass: "tab-swiper vux-center"
	    }, [_vm._v(_vm._s(item) + " Container")])])])
	  }))], 1)
	},staticRenderFns: []}

/***/ },
/* 277 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vux-alert"
	  }, [_c('x-dialog', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.showValue),
	      expression: "showValue"
	    }],
	    staticClass: "weui_dialog_alert",
	    attrs: {
	      "mask-transition": _vm.maskTransition,
	      "dialog-transition": _vm.dialogTransition
	    },
	    domProps: {
	      "value": (_vm.showValue)
	    },
	    on: {
	      "on-hide": function($event) {
	        _vm.$emit('on-hide')
	      },
	      "on-show": function($event) {
	        _vm.$emit('on-show')
	      },
	      "input": function($event) {
	        _vm.showValue = $event
	      }
	    }
	  }, [_c('div', {
	    staticClass: "weui_dialog_hd"
	  }, [_c('strong', {
	    staticClass: "weui_dialog_title"
	  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
	    staticClass: "weui_dialog_bd"
	  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
	    staticClass: "weui_dialog_ft"
	  }, [_c('a', {
	    staticClass: "weui_btn_dialog primary",
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": _vm.onHide
	    }
	  }, [_vm._v(_vm._s(_vm.buttonText || _vm.$t('button_text')))])])])], 1)
	},staticRenderFns: []}

/***/ },
/* 278 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "parent"
	  }, [_c('sticky', {
	    attrs: {
	      "scroll-box": "vux_view_box_body",
	      "offset": 46
	    }
	  }, [_c('x-header', {
	    attrs: {
	      "left-options": {
	        preventGoBack: true,
	        showBack: true
	      }
	    },
	    on: {
	      "on-click-back": _vm.goHome
	    }
	  }), _vm._v(" "), _c('tab', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.index),
	      expression: "index"
	    }],
	    attrs: {
	      "line-width": 2,
	      "active-color": "#fc378c"
	    },
	    domProps: {
	      "value": (_vm.index)
	    },
	    on: {
	      "input": function($event) {
	        _vm.index = $event
	      }
	    }
	  }, _vm._l((_vm.list2), function(item) {
	    return _c('tab-item', {
	      staticClass: "vux-center",
	      attrs: {
	        "selected": _vm.demo2 === item
	      },
	      on: {
	        "click": function($event) {
	          _vm.demo2 = item
	        },
	        "on-item-click": function($event) {
	          _vm.handler(item)
	        }
	      }
	    }, [_vm._v(_vm._s(item))])
	  }))], 1), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": _vm.transitionName
	    }
	  }, [_c('router-view', {
	    staticClass: "child-view"
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ },
/* 279 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticClass: "vux-divider"
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ },
/* 280 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "weui_panel weui_panel_access"
	  }, [(_vm.header && _vm.header.title) ? _c('div', {
	    staticClass: "weui_panel_hd",
	    domProps: {
	      "innerHTML": _vm._s(_vm.header.title)
	    },
	    on: {
	      "click": function($event) {
	        _vm.$emit('on-click-header')
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), _vm._t("header"), _vm._v(" "), _c('div', {
	    staticClass: "weui_panel_bd"
	  }, [_c('div', {
	    staticClass: "vux-card-content"
	  }, [_vm._t("content")], 2)]), _vm._v(" "), (_vm.footer && _vm.footer.title) ? _c('a', {
	    staticClass: "weui_panel_ft",
	    attrs: {
	      "href": "javascript:"
	    },
	    domProps: {
	      "innerHTML": _vm._s(_vm.footer.title)
	    },
	    on: {
	      "click": _vm.onClickFooter
	    }
	  }) : _vm._e(), _vm._v(" "), _vm._t("footer")], 2)
	},staticRenderFns: []}

/***/ },
/* 281 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vux-header"
	  }, [_c('div', {
	    staticClass: "vux-header-left"
	  }, [_c('a', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.leftOptions.showBack),
	      expression: "leftOptions.showBack"
	    }],
	    staticClass: "vux-header-back",
	    attrs: {
	      "transition": _vm.transition
	    },
	    on: {
	      "click": [function($event) {
	        if (_vm._k($event.keyCode, "preventDefault")) { return; }
	      }, _vm.onClickBack]
	    }
	  }, [_vm._v(_vm._s(_vm.leftOptions.backText))]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.leftOptions.showBack),
	      expression: "leftOptions.showBack"
	    }],
	    staticClass: "left-arrow",
	    attrs: {
	      "transition": _vm.transition
	    },
	    on: {
	      "click": _vm.onClickBack
	    }
	  }), _vm._v(" "), _vm._t("left")], 2), _vm._v(" "), _c('h1', {
	    staticClass: "vux-header-title",
	    on: {
	      "click": function($event) {
	        _vm.$emit('on-click-title')
	      }
	    }
	  }, [_c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.title),
	      expression: "title"
	    }],
	    attrs: {
	      "transition": _vm.transition
	    }
	  }, [_vm._v(_vm._s(_vm.title))]), _vm._t("default")], 2), _vm._v(" "), _c('div', {
	    staticClass: "vux-header-right"
	  }, [(_vm.rightOptions.showMore) ? _c('a', {
	    staticClass: "vux-header-more",
	    on: {
	      "click": [function($event) {
	        if (_vm._k($event.keyCode, "preventDefault")) { return; }
	      }, function($event) {
	        _vm.$emit('on-click-more')
	      }]
	    }
	  }) : _vm._e(), _vm._v(" "), _vm._t("right")], 2)])
	},staticRenderFns: []}

/***/ },
/* 282 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "echarts"
	  }, [_c('chart', {
	    ref: "pie",
	    attrs: {
	      "options": _vm.pie3
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ },
/* 283 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show),
	      expression: "show"
	    }],
	    staticClass: "weui_loading_toast"
	  }, [_c('div', {
	    staticClass: "weui_mask_transparent"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "weui_toast",
	    style: ({
	      position: _vm.position
	    })
	  }, [_c('i', {
	    staticClass: "weui-loading weui-icon_toast"
	  }), _vm._v(" "), _c('p', {
	    staticClass: "weui_toast_content"
	  }, [_vm._v(_vm._s(_vm.$t(_vm.text) || _vm.$t('loading'))), _vm._t("default")], 2)])])
	},staticRenderFns: []}

/***/ },
/* 284 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vux-swiper-item"
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ },
/* 285 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "weui_btn",
	    class: _vm.classes,
	    attrs: {
	      "disabled": _vm.disabled
	    }
	  }, [_vm._v("\n  " + _vm._s(_vm.text)), _vm._t("default")], 2)
	},staticRenderFns: []}

/***/ },
/* 286 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vux-search-box",
	    class: {
	      'vux-search-fixed': _vm.isFixed
	    },
	    style: ({
	      top: _vm.isFixed ? _vm.top : ''
	    })
	  }, [_c('div', {
	    staticClass: "weui_search_bar",
	    class: {
	      weui_search_focusing: !_vm.isCancel
	    },
	    attrs: {
	      "id": "search_bar"
	    }
	  }, [_c('form', {
	    staticClass: "weui_search_outer",
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.$emit('on-submit', _vm.value)
	      }
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.isFixed && _vm.autoFixed),
	      expression: "!isFixed && autoFixed"
	    }],
	    staticClass: "vux-search-mask",
	    on: {
	      "click": _vm.touch
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "weui_search_inner"
	  }, [_c('i', {
	    staticClass: "weui_icon_search"
	  }), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.currentValue),
	      expression: "currentValue"
	    }],
	    ref: "input",
	    staticClass: "weui_search_input",
	    attrs: {
	      "type": "search",
	      "id": "search_input",
	      "placeholder": _vm.placeholder,
	      "autocomplete": "off",
	      "required": _vm.required
	    },
	    domProps: {
	      "value": _vm._s(_vm.currentValue)
	    },
	    on: {
	      "focus": function($event) {
	        _vm.isFocus = true
	      },
	      "blur": function($event) {
	        _vm.isFocus = false
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.currentValue = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "weui_icon_clear",
	    attrs: {
	      "href": "javascript:",
	      "id": "search_clear"
	    },
	    on: {
	      "click": _vm.clear
	    }
	  })]), _vm._v(" "), _c('label', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.isFocus && !_vm.value),
	      expression: "!isFocus && !value"
	    }],
	    staticClass: "weui_search_text",
	    attrs: {
	      "for": "search_input",
	      "id": "search_text"
	    }
	  }, [_c('i', {
	    staticClass: "weui_icon_search"
	  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.placeholder || _vm.$t('placeholder')))])])]), _vm._v(" "), _c('a', {
	    staticClass: "weui_search_cancel",
	    attrs: {
	      "href": "javascript:",
	      "id": "search_cancel"
	    },
	    on: {
	      "click": _vm.cancel
	    }
	  }, [_vm._v(_vm._s(_vm.cancelText || _vm.$t('cancel_text')))])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.isFixed),
	      expression: "isFixed"
	    }],
	    staticClass: "weui_cells weui_cells_access vux-search_show",
	    attrs: {
	      "id": "search_show"
	    }
	  }, [_vm._t("default"), _vm._v(" "), _vm._l((_vm.results), function(item) {
	    return _c('div', {
	      staticClass: "weui_cell",
	      on: {
	        "click": function($event) {
	          _vm.handleResultClick(item)
	        },
	        "touchmove": function($event) {
	          $event.preventDefault();
	        }
	      }
	    }, [_c('div', {
	      staticClass: "weui_cell_bd weui_cell_primary"
	    }, [_c('p', [_vm._v(_vm._s(item.title))])])])
	  })], 2)])
	},staticRenderFns: []}

/***/ },
/* 287 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "hello"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('h2', [_vm._v("Essential Links")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', [_vm._v("Ecosystem")]), _vm._v(" "), _vm._m(1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ul', [_c('li', [_c('a', {
	    attrs: {
	      "href": "https://vuejs.org",
	      "target": "_blank"
	    }
	  }, [_vm._v("Core Docs")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://forum.vuejs.org",
	      "target": "_blank"
	    }
	  }, [_vm._v("Forum")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://gitter.im/vuejs/vue",
	      "target": "_blank"
	    }
	  }, [_vm._v("Gitter Chat")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://twitter.com/vuejs",
	      "target": "_blank"
	    }
	  }, [_vm._v("Twitter")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "http://vuejs-templates.github.io/webpack/",
	      "target": "_blank"
	    }
	  }, [_vm._v("Docs for This Template")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ul', [_c('li', [_c('a', {
	    attrs: {
	      "href": "http://router.vuejs.org/",
	      "target": "_blank"
	    }
	  }, [_vm._v("vue-router")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "http://vuex.vuejs.org/",
	      "target": "_blank"
	    }
	  }, [_vm._v("vuex")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "http://vue-loader.vuejs.org/",
	      "target": "_blank"
	    }
	  }, [_vm._v("vue-loader")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://github.com/vuejs/awesome-vue",
	      "target": "_blank"
	    }
	  }, [_vm._v("awesome-vue")])])])
	}]}

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_vm._m(0), _vm._v(" "), _c('group', {
	    attrs: {
	      "title": "cell demo"
	    }
	  }, [_c('cell', {
	    attrs: {
	      "title": "Vux",
	      "value": "Cool",
	      "is-link": ""
	    }
	  })], 1)], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vux-demo"
	  }, [_c('img', {
	    staticClass: "logo",
	    attrs: {
	      "src": __webpack_require__(211)
	    }
	  }), _vm._v(" "), _c('h1')])
	}]}

/***/ },
/* 289 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vux-slider"
	  }, [_c('div', {
	    staticClass: "vux-swiper",
	    style: ({
	      height: _vm.xheight
	    })
	  }, [_vm._t("default"), _vm._v(" "), _vm._l((_vm.list), function(item, index) {
	    return _c('div', {
	      staticClass: "vux-swiper-item",
	      attrs: {
	        "data-index": index
	      },
	      on: {
	        "click": function($event) {
	          _vm.clickListItem(item)
	        }
	      }
	    }, [_c('a', {
	      attrs: {
	        "href": "javascript:"
	      }
	    }, [_c('div', {
	      staticClass: "vux-img",
	      style: ({
	        backgroundImage: _vm.buildBackgroundUrl(item.img)
	      })
	    }), _vm._v(" "), (_vm.showDescMask) ? _c('p', {
	      staticClass: "vux-swiper-desc"
	    }, [_vm._v(_vm._s(item.title))]) : _vm._e()])])
	  })], 2), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showDots),
	      expression: "showDots"
	    }],
	    class: [_vm.dotsClass, 'vux-indicator', 'vux-indicator-' + _vm.dotsPosition]
	  }, _vm._l((_vm.length), function(key) {
	    return _c('a', {
	      attrs: {
	        "href": "javascript:"
	      }
	    }, [_c('i', {
	      staticClass: "vux-icon-dot",
	      class: {
	        'active': key - 1 === _vm.current
	      }
	    })])
	  }))])
	},staticRenderFns: []}

/***/ },
/* 290 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "weui_cell",
	    class: {
	      'vux-tap-active': _vm.isLink || !!_vm.link
	    },
	    on: {
	      "click": _vm.onClick
	    }
	  }, [_c('div', {
	    staticClass: "weui_cell_hd"
	  }, [_vm._t("icon")], 2), _vm._v(" "), _c('div', {
	    staticClass: "weui_cell_bd",
	    class: {
	      'weui_cell_primary': _vm.primary === 'title'
	    }
	  }, [_c('p', [_vm._v("\n      " + _vm._s(_vm.title) + "\n      "), _vm._t("after-title")], 2), _vm._v(" "), _c('inline-desc', [_vm._v(_vm._s(_vm.inlineDesc))])], 1), _vm._v(" "), _c('div', {
	    staticClass: "weui_cell_ft",
	    class: {
	      'weui_cell_primary': _vm.primary === 'content', 'with_arrow': _vm.isLink || !!_vm.link
	    }
	  }, [_vm._v("\n    " + _vm._s(_vm.value) + "\n    "), _vm._t("value"), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _vm._t("child")], 2)
	},staticRenderFns: []}

/***/ },
/* 291 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ },
/* 292 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.title) ? _c('div', {
	    staticClass: "weui_cells_title",
	    style: ({
	      color: _vm.titleColor
	    }),
	    domProps: {
	      "innerHTML": _vm._s(_vm.title)
	    }
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "weui_cells",
	    class: {
	      'vux-no-group-title': !_vm.title
	    },
	    style: ({
	      marginTop: _vm.gutter
	    })
	  }, [_vm._t("after-title"), _vm._v(" "), _vm._t("default")], 2)])
	},staticRenderFns: []}

/***/ },
/* 293 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "echarts"
	  })
	},staticRenderFns: []}

/***/ },
/* 294 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vux-tab",
	    class: {
	      'vux-tab-no-animate': !_vm.animate
	    }
	  }, [_vm._t("default"), _vm._v(" "), (_vm.animate) ? _c('div', {
	    staticClass: "vux-tab-ink-bar",
	    class: _vm.barClass,
	    style: (_vm.barStyle)
	  }) : _vm._e()], 2)
	},staticRenderFns: []}

/***/ },
/* 295 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('main-layout', [_c('div', {
	    staticClass: "container"
	  }, [_c('search', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.community),
	      expression: "community"
	    }],
	    attrs: {
	      "auto-fixed": false,
	      "placeholder": "请输入小区名(查询一次仅需1钢蹦)"
	    },
	    domProps: {
	      "value": (_vm.community)
	    },
	    on: {
	      "on-submit": _vm.submit,
	      "input": function($event) {
	        _vm.community = $event
	      }
	    }
	  }), _vm._v(" "), _c('divider', [_vm._v("-")]), _vm._v(" "), _c('div', {
	    staticClass: "center"
	  }, [_c('confirm', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.show),
	      expression: "show"
	    }],
	    attrs: {
	      "title": _vm.show_title,
	      "confirm-text": _vm.btn_ok,
	      "cancel-text": _vm.btn_cancel
	    },
	    domProps: {
	      "value": (_vm.show)
	    },
	    on: {
	      "on-cancel": _vm.onCancel,
	      "on-confirm": _vm.onConfirm,
	      "input": function($event) {
	        _vm.show = $event
	      }
	    }
	  }, [_c('p', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_vm._v(_vm._s(_vm.show_content))])]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.subtitleMsg))]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.coins >= 1) ? _c('div', _vm._l((_vm.lists), function(item) {
	    return _c('div', {
	      key: item,
	      staticClass: "list-item"
	    }, [_c('p', {
	      staticClass: "p-padding"
	    }), (_vm.pageType === '0') ? _c('div', [_c('router-link', {
	      attrs: {
	        "to": {
	          path: '/test',
	          query: {
	            cm: item,
	            type: _vm.reqType
	          }
	        }
	      }
	    }, [_vm._v("\n            " + _vm._s(item) + "\n            ")])], 1) : _c('div', [_c('router-link', {
	      attrs: {
	        "to": {
	          path: '/test',
	          query: {
	            cm: item,
	            type: _vm.reqType
	          }
	        }
	      }
	    }, [_vm._v("\n            " + _vm._s(item) + "\n            ")])], 1), _vm._v(" "), _c('p')])
	  })) : _vm._e()], 1)], 1)])
	},staticRenderFns: []}

/***/ },
/* 296 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('main-layout', [_c('div', {
	    staticClass: "container"
	  }, [_c('search', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.community),
	      expression: "community"
	    }],
	    attrs: {
	      "auto-fixed": false,
	      "placeholder": "请输入小区名(查询一次仅需1钢蹦)"
	    },
	    domProps: {
	      "value": (_vm.community)
	    },
	    on: {
	      "on-submit": _vm.submit,
	      "input": function($event) {
	        _vm.community = $event
	      }
	    }
	  }), _vm._v(" "), _c('divider', [_vm._v("-")]), _vm._v(" "), _c('div', {
	    staticClass: "center"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.subtitleMsg))]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.lists), function(item) {
	    return _c('div', {
	      key: item,
	      staticClass: "list-item"
	    }, [_c('p', {
	      staticClass: "p-padding"
	    }), (_vm.pageType === '0') ? _c('div', [_c('router-link', {
	      attrs: {
	        "to": {
	          path: '/detail',
	          query: {
	            cm: item,
	            type: _vm.reqType
	          }
	        }
	      }
	    }, [_vm._v("\n            " + _vm._s(item) + "\n            ")])], 1) : _c('div', [_c('router-link', {
	      attrs: {
	        "to": {
	          path: '/detail',
	          query: {
	            cm: item,
	            type: _vm.reqType
	          }
	        }
	      }
	    }, [_vm._v("\n            " + _vm._s(item) + "\n            ")])], 1), _vm._v(" "), _c('p')])
	  })], 2)], 1)])
	},staticRenderFns: []}

/***/ },
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  baseOption: {
	    title: {
	      text: '成交数量',
	      subtext: '数据来自网络'
	    },
	    tooltip: {
	      trigger: 'axis'
	    },
	    legend: {
	      orient: 'vertical',
	      data: ['phpdata', '北京']
	    },
	    grid: {
	      show: true,
	      left: '1%',
	      right: '1%',
	
	      containLabel: true
	    },
	    toolbox: {
	      feature: {
	        dataZoom: { yAxisIndex: 'none' },
	        dataView: { readOnly: false },
	        saveAsImage: {}
	      }
	    },
	    xAxis: {
	      type: 'value',
	      scale: true,
	      position: 'top'
	    },
	    yAxis: {
	      type: 'category',
	      inverse: true,
	      boundaryGap: true,
	      data: ['phpdata']
	    },
	    series: [{
	      name: 'phpdata',
	      type: 'bar',
	      data: ['phpdata'],
	      markPoint: {
	        data: [{ type: 'max', name: '最大值' }, { type: 'min', name: '最小值' }]
	      },
	      markLine: {
	        data: [{ type: 'average', name: '平均值' }]
	      }
	    }, {
	      name: '北京',
	      type: 'bar',
	      data: ['phpdata']
	    }]
	  },
	  media: [{
	    option: {
	      grid: {
	        show: true,
	        left: '1%',
	        right: '1%',
	        bottom: '1%',
	        containLabel: true
	      }
	    }
	  }, {
	    query: {
	      maxWidth: 320 },
	    option: {
	      grid: {
	        show: true,
	        left: '1%',
	        right: '1%',
	        bottom: '30%',
	        containLabel: true
	      }
	    }
	  }]
	};

/***/ },
/* 602 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  baseOption: {
	    title: {
	      text: '成交价格',
	      subtext: '数据来自网络'
	    },
	    tooltip: {
	      trigger: 'axis'
	    },
	    legend: {
	      orient: 'vertical',
	      data: ['目标小区', '北京']
	    },
	    grid: {
	      show: true,
	      left: '1%',
	      right: '1%',
	
	      containLabel: true
	    },
	    toolbox: {
	      feature: {
	        dataZoom: { xAxisIndex: 'none' },
	        dataView: { readOnly: false },
	        saveAsImage: {}
	      }
	    },
	    xAxis: {
	      type: 'value',
	      scale: true,
	      position: 'top'
	    },
	    yAxis: {
	      type: 'category',
	      inverse: true,
	
	      boundaryGap: true,
	      data: []
	    },
	    series: [{
	      name: '',
	      type: 'line',
	      data: [],
	      markPoint: {
	        data: [{ type: 'max', name: '最大值' }, { type: 'min', name: '最小值' }]
	      },
	      markLine: {
	        data: [{ type: 'average', name: '平均值' }]
	      }
	    }, {
	      name: '北京',
	      type: 'line',
	      data: []
	    }]
	  },
	  media: [{
	    option: {
	      grid: {
	        show: true,
	        left: '1%',
	        right: '1%',
	        bottom: '1%',
	        containLabel: true
	      }
	    }
	  }, {
	    query: {
	      maxWidth: 320 },
	    option: {
	      grid: {
	        show: true,
	        left: '1%',
	        right: '1%',
	        bottom: '30%',
	        containLabel: true
	      }
	    }
	  }]
	
	};

/***/ },
/* 603 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    baseOption: {
	        title: {
	            text: '成交数量',
	            subtext: '数据来自网络'
	        },
	        tooltip: {
	            trigger: 'item',
	            formatter: "{a} <br/>{b} : {c} ({d}%)"
	        },
	        legend: {
	            data: ['rose1', 'rose2', 'rose3', 'rose4', 'rose5', 'rose6', 'rose7', 'rose8']
	        },
	        toolbox: {
	            show: true,
	            feature: {
	                mark: { show: true },
	                dataView: { show: true, readOnly: false },
	                magicType: {
	                    show: true,
	                    type: ['pie', 'funnel']
	                },
	                restore: { show: true },
	                saveAsImage: { show: true }
	            }
	        },
	        calculable: true,
	        series: [{
	            name: '半径模式',
	            type: 'pie',
	            roseType: 'radius',
	            label: {
	                normal: {
	                    show: true
	                },
	                emphasis: {
	                    show: true
	                }
	            },
	            lableLine: {
	                normal: {
	                    show: true
	                },
	                emphasis: {
	                    show: true
	                }
	            },
	            data: [{ value: 10, name: 'rose1' }, { value: 5, name: 'rose2' }, { value: 15, name: 'rose3' }, { value: 25, name: 'rose4' }, { value: 20, name: 'rose5' }, { value: 35, name: 'rose6' }, { value: 30, name: 'rose7' }, { value: 40, name: 'rose8' }]
	        }, {
	            name: '面积模式',
	            type: 'pie',
	            roseType: 'area',
	            data: [{ value: 10, name: 'rose1' }, { value: 5, name: 'rose2' }, { value: 15, name: 'rose3' }, { value: 25, name: 'rose4' }, { value: 20, name: 'rose5' }, { value: 35, name: 'rose6' }, { value: 30, name: 'rose7' }, { value: 40, name: 'rose8' }]
	        }]
	    },
	    media: [{
	        option: {
	            legend: {
	                right: 'center',
	
	                orient: 'horizontal'
	            },
	            series: [{
	                radius: ['10%', '30%'],
	                center: ['50%', '30%']
	            }, {
	                radius: ['10%', '30%'],
	                center: ['50%', '65%']
	            }]
	        }
	    }]
	
	};

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(133);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(41);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _vuexI18n = __webpack_require__(132);
	
	var _vuexI18n2 = _interopRequireDefault(_vuexI18n);
	
	var _vux = __webpack_require__(606);
	
	var _vux2 = _interopRequireDefault(_vux);
	
	var _jw = __webpack_require__(605);
	
	var _jw2 = _interopRequireDefault(_jw);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var debug = ("production") !== 'production';
	
	exports.default = new _vuex2.default.Store({
	  modules: {
	    i18n: _vuexI18n2.default.store,
	    vux: _vux2.default,
	    jw: _jw2.default
	  },
	  strict: debug
	});

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(640);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  type: null,
	  detailData: null,
	  count: 0
	};
	
	var mutations = {
	  increment: function increment(state) {
	    state.count++;
	  },
	  decrement: function decrement(state) {
	    state.count--;
	  },
	  updateType: function updateType(state, type) {
	    console.log("updateType > input type:%s, state type:%s", type, state.type);
	    state.type = type;
	    console.log("updateType > update type:%s", state.type);
	  },
	  updateData: function updateData(state, data) {
	    console.debug("updateData > input data:%o, state detailData:%o", data, state.detailData);
	    state.detailData = data;
	    console.debug("updateData > update detailData:%o", state.detailData);
	  },
	  clearData: function clearData(state) {
	    state.detailData = {};
	    console.debug("clearData > clear detailData:" + state.detailData);
	  }
	};
	
	var actions = {
	  increment: function increment(_ref) {
	    var commit = _ref.commit;
	    return commit('increment');
	  },
	  decrement: function decrement(_ref2) {
	    var commit = _ref2.commit;
	    return commit('decrement');
	  },
	  incrementIfOdd: function incrementIfOdd(_ref3) {
	    var commit = _ref3.commit,
	        state = _ref3.state;
	
	    if ((state.count + 1) % 2 === 0) {
	      commit('increment');
	    }
	  },
	  incrementAsync: function incrementAsync(_ref4) {
	    var commit = _ref4.commit;
	
	    return new _promise2.default(function (resolve, reject) {
	      setTimeout(function () {
	        commit('increment');
	        resolve();
	      }, 1000);
	    });
	  }
	};
	
	var getters = {
	  evenOrOdd: function evenOrOdd(state) {
	    return state.count % 2 === 0 ? 'even' : 'odd';
	  }
	};
	
	exports.default = {
	  state: state,
	  getters: getters,
	  actions: actions,
	  mutations: mutations
	};

/***/ },
/* 606 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var state = {
	  isLoading: false,
	  direction: 'forward'
	};
	
	var mutations = {
	  UPDATE_LOADING: function UPDATE_LOADING(state, status) {
	    state.isLoading = status;
	  },
	  UPDATE_DIRECTION: function UPDATE_DIRECTION(state, direction) {
	    state.direction = direction;
	  }
	};
	
	var actions = {
	  updateDemoPosition: function updateDemoPosition(_ref, top) {
	    var commit = _ref.commit;
	
	    commit({ type: 'updateDemoPosition', top: top });
	  }
	};
	
	var getters = {};
	
	exports.default = {
	  state: state,
	  getters: getters,
	  actions: actions,
	  mutations: mutations
	};

/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _xDialog = __webpack_require__(131);
	
	var _xDialog2 = _interopRequireDefault(_xDialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    XDialog: _xDialog2.default
	  },
	  created: function created() {
	    if (typeof this.value !== 'undefined') {
	      this.showValue = this.value;
	    }
	  },
	
	  props: {
	    value: Boolean,
	    title: String,
	    buttonText: String,
	    maskTransition: {
	      type: String,
	      default: 'vux-fade'
	    },
	    dialogTransition: {
	      type: String,
	      default: 'vux-dialog'
	    }
	  },
	  data: function data() {
	    return {
	      showValue: false
	    };
	  },
	
	  methods: {
	    onHide: function onHide() {
	      this.showValue = false;
	    }
	  },
	  watch: {
	    value: function value(val) {
	      this.showValue = val;
	    },
	    showValue: function showValue(val) {
	      this.$emit('input', val);
	    }
	  }
	};

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _router = __webpack_require__(82);
	
	exports.default = {
	  props: {
	    header: Object,
	    footer: Object
	  },
	  methods: {
	    onClickFooter: function onClickFooter() {
	      this.footer.link && (0, _router.go)(this.footer.link, this.$router);
	      this.$emit('on-click-footer');
	    }
	  }
	};

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inlineDesc = __webpack_require__(244);
	
	var _inlineDesc2 = _interopRequireDefault(_inlineDesc);
	
	var _router = __webpack_require__(82);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    InlineDesc: _inlineDesc2.default
	  },
	  props: {
	    title: String,
	    value: [String, Number, Array],
	    isLink: Boolean,
	    inlineDesc: [String, Number],
	    primary: {
	      type: String,
	      default: 'title'
	    },
	    link: {
	      type: [String, Object]
	    }
	  },
	  methods: {
	    onClick: function onClick() {
	      (0, _router.go)(this.link, this.$router);
	    }
	  }
	};

/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _xDialog = __webpack_require__(131);
	
	var _xDialog2 = _interopRequireDefault(_xDialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    XDialog: _xDialog2.default
	  },
	  props: {
	    value: {
	      type: Boolean,
	      default: false
	    },
	    hideOnBlur: {
	      type: Boolean,
	      default: false
	    },
	    title: String,
	    confirmText: String,
	    cancelText: String,
	    maskTransition: {
	      type: String,
	      default: 'vux-fade'
	    },
	    dialogTransition: {
	      type: String,
	      default: 'vux-dialog'
	    },
	    content: String
	  },
	  created: function created() {
	    this.showValue = this.show;
	    if (this.value) {
	      this.showValue = this.value;
	    }
	  },
	
	  watch: {
	    value: function value(val) {
	      this.showValue = val;
	    },
	    showValue: function showValue(val) {
	      this.$emit('input', val);
	    }
	  },
	  data: function data() {
	    return {
	      showValue: false
	    };
	  },
	
	  methods: {
	    onConfirm: function onConfirm() {
	      this.showValue = false;
	      this.$emit('on-confirm');
	    },
	    onCancel: function onCancel() {
	      this.showValue = false;
	      this.$emit('on-cancel');
	    }
	  }
	};

/***/ },
/* 611 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    title: String,
	    titleColor: String,
	    labelWidth: String,
	    labelAlign: String,
	    labelMarginRight: String,
	    gutter: String
	  }
	};

/***/ },
/* 612 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    value: {
	      type: Boolean,
	      default: false
	    },
	    text: String,
	    position: String
	  },
	  created: function created() {
	    this.show = this.value;
	  },
	  data: function data() {
	    return {
	      show: false
	    };
	  },
	
	  watch: {
	    value: function value(val) {
	      this.show = val;
	    },
	    show: function show(val) {
	      this.$emit('input', val);
	    }
	  }
	};

/***/ },
/* 613 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    required: {
	      type: Boolean,
	      default: false
	    },
	    placeholder: String,
	    cancelText: String,
	    value: {
	      type: String,
	      default: ''
	    },
	    results: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    autoFixed: {
	      type: Boolean,
	      default: true
	    },
	    top: {
	      type: String,
	      default: '0px'
	    }
	  },
	  created: function created() {
	    if (this.value) {
	      this.currentValue = this.value;
	    }
	  },
	
	  methods: {
	    clear: function clear() {
	      this.currentValue = '';
	      this.isFocus = true;
	      this.setFocus();
	    },
	    cancel: function cancel() {
	      this.currentValue = '';
	      this.isCancel = true;
	      this.isFixed = false;
	      this.$emit('on-cancel');
	    },
	    handleResultClick: function handleResultClick(item) {
	      this.$emit('result-click', item);
	      this.isCancel = true;
	      this.isFixed = false;
	    },
	    touch: function touch() {
	      this.isCancel = false;
	      if (this.autoFixed) {
	        this.isFixed = true;
	      }
	      this.$emit('on-touch');
	    },
	    setFocus: function setFocus() {
	      this.$refs.input.focus();
	    }
	  },
	  data: function data() {
	    return {
	      currentValue: '',
	      isCancel: true,
	      isFocus: false,
	      isFixed: false
	    };
	  },
	
	  watch: {
	    isFixed: function isFixed(val) {
	      if (val === true) {
	        this.setFocus();
	        this.isFocus = true;
	      } else {}
	    },
	    value: function value(val) {
	      this.currentValue = val;
	    },
	    currentValue: function currentValue(val) {
	      this.$emit('on-change', val);
	      this.$emit('input', val);
	    }
	  }
	};

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sticky = __webpack_require__(635);
	
	var _sticky2 = _interopRequireDefault(_sticky);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mounted: function mounted() {
	    var _this = this;
	
	    this.$nextTick(function () {
	      (0, _sticky2.default)(_this.$el);
	    });
	  }
	};

/***/ },
/* 615 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  mounted: function mounted() {
	    var _this = this;
	
	    this.$nextTick(function () {
	      _this.$parent.rerender();
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    var $parent = this.$parent;
	    this.$nextTick(function () {
	      $parent.rerender();
	    });
	  }
	};

/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(209);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _swiper = __webpack_require__(636);
	
	var _swiper2 = _interopRequireDefault(_swiper);
	
	var _router = __webpack_require__(82);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  created: function created() {
	    this.index = this.value || 0;
	    if (this.index) {
	      this.current = this.index;
	    }
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    this.$nextTick(function () {
	      if (!(_this2.list && _this2.list.length === 0)) {
	        _this2.render();
	      }
	      _this2.xheight = _this2.getHeight();
	    });
	  },
	
	  methods: {
	    clickListItem: function clickListItem(item) {
	      (0, _router.go)(item.url, this.$router);
	      this.$emit('on-click-list-item', JSON.parse((0, _stringify2.default)(item)));
	    },
	    buildBackgroundUrl: function buildBackgroundUrl(url) {
	      return 'url(' + url + ')';
	    },
	    render: function render() {
	      var _this3 = this;
	
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      this.swiper && this.swiper.destroy();
	      this.swiper = new _swiper2.default({
	        container: this.$el,
	        direction: this.direction,
	        auto: this.auto,
	        loop: this.loop,
	        interval: this.interval,
	        threshold: this.threshold,
	        duration: this.duration,
	        height: this.height || this._height,
	        minMovingDistance: this.minMovingDistance,
	        imgList: this.imgList
	      }).on('swiped', function (prev, index) {
	        _this3.current = index % _this3.length;
	        _this3.index = index % _this3.length;
	      });
	      if (index > 0) {
	        this.swiper.go(index);
	      }
	    },
	    rerender: function rerender() {
	      var _this4 = this;
	
	      if (!this.$el) {
	        return;
	      }
	      this.$nextTick(function () {
	        _this4.index = _this4.value || 0;
	        _this4.current = _this4.value || 0;
	        _this4.length = _this4.list.length || _this4.$children.length;
	        _this4.destroy();
	        _this4.render(_this4.value);
	      });
	    },
	    destroy: function destroy() {
	      this.swiper && this.swiper.destroy();
	    },
	    getHeight: function getHeight() {
	      var hasHeight = parseInt(this.height, 10);
	      if (hasHeight) return this.height;
	      if (!hasHeight) {
	        if (this.aspectRatio) {
	          return this.$el.offsetWidth * this.aspectRatio + 'px';
	        }
	        return '180px';
	      }
	    }
	  },
	  props: {
	    list: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    direction: {
	      type: String,
	      default: 'horizontal'
	    },
	    showDots: {
	      type: Boolean,
	      default: true
	    },
	    showDescMask: {
	      type: Boolean,
	      default: true
	    },
	    dotsPosition: {
	      type: String,
	      default: 'right'
	    },
	    dotsClass: String,
	    auto: {
	      type: Boolean,
	      default: false
	    },
	    loop: Boolean,
	    interval: {
	      type: Number,
	      default: 3000
	    },
	    threshold: {
	      type: Number,
	      default: 50
	    },
	    duration: {
	      type: Number,
	      default: 300
	    },
	    height: {
	      type: String,
	      default: 'auto'
	    },
	    aspectRatio: Number,
	    minMovingDistance: {
	      type: Number,
	      default: 0
	    },
	    value: {
	      type: Number,
	      default: 0
	    }
	  },
	  data: function data() {
	    return {
	      current: this.index || 0,
	      xheight: 'auto',
	      length: this.list.length,
	      index: 0
	    };
	  },
	
	  watch: {
	    list: function list(val) {
	      this.rerender();
	    },
	    current: function current(currentIndex) {
	      this.index = currentIndex;
	      this.$emit('on-index-change', currentIndex);
	    },
	    index: function index(val) {
	      var _this = this;
	      if (val !== this.current) {
	        this.$nextTick(function () {
	          _this.swiper && _this.swiper.go(val);
	        });
	      }
	      this.$emit('input', val);
	    },
	    value: function value(val) {
	      this.index = val;
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.destroy();
	  }
	};

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _multiItems = __webpack_require__(208);
	
	exports.default = {
	  mixins: [_multiItems.childMixin],
	  props: {
	    activeClass: String,
	    disabled: Boolean
	  },
	  computed: {
	    style: function style() {
	      return {
	        borderWidth: this.$parent.lineWidth + 'px',
	        borderColor: this.$parent.activeColor,
	        color: this.currentSelected ? this.$parent.activeColor : this.disabled ? this.$parent.disabledColor : this.$parent.defaultColor,
	        border: this.$parent.animate ? 'none' : 'auto'
	      };
	    }
	  }
	};

/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _multiItems = __webpack_require__(208);
	
	exports.default = {
	  mixins: [_multiItems.parentMixin],
	  mounted: function mounted() {
	    var _this = this;
	
	    this.$nextTick(function () {
	      setTimeout(function () {
	        _this.hasReady = true;
	      }, 0);
	    });
	  },
	
	  props: {
	    lineWidth: {
	      type: Number,
	      default: 3
	    },
	    activeColor: String,
	    defaultColor: String,
	    disabledColor: String,
	    animate: {
	      type: Boolean,
	      default: true
	    }
	  },
	  computed: {
	    barLeft: function barLeft() {
	      return this.currentIndex * (100 / this.number) + '%';
	    },
	    barRight: function barRight() {
	      return (this.number - this.currentIndex - 1) * (100 / this.number) + '%';
	    },
	    barStyle: function barStyle() {
	      return {
	        left: this.barLeft,
	        right: this.barRight,
	        display: 'block',
	        backgroundColor: this.activeColor,
	        height: this.lineWidth + 'px',
	        transition: !this.hasReady ? 'none' : null
	      };
	    },
	    barClass: function barClass() {
	      return {
	        'vux-tab-ink-bar-transition-forward': this.direction === 'forward',
	        'vux-tab-ink-bar-transition-backward': this.direction === 'backward'
	      };
	    }
	  },
	  watch: {
	    currentIndex: function currentIndex(newIndex, oldIndex) {
	      this.direction = newIndex > oldIndex ? 'forward' : 'backward';
	      this.$emit('on-index-change', newIndex, oldIndex);
	    }
	  },
	  data: function data() {
	    return {
	      direction: 'forward',
	      right: '100%',
	      hasReady: false
	    };
	  }
	};

/***/ },
/* 619 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    type: {
	      default: 'default'
	    },
	    disabled: Boolean,
	    mini: Boolean,
	    plain: Boolean,
	    text: String
	  },
	  computed: {
	    classes: function classes() {
	      return [{
	        weui_btn_disabled: this.disabled,
	        weui_btn_mini: this.mini
	      }, 'weui_btn_' + this.type, this.plain ? 'weui_btn_plain_' + this.type : ''];
	    }
	  }
	};

/***/ },
/* 620 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    value: {
	      type: Boolean,
	      default: false
	    },
	    maskTransition: {
	      type: String,
	      default: 'vux-fade'
	    },
	    dialogTransition: {
	      type: String,
	      default: 'vux-dialog'
	    },
	    hideOnBlur: Boolean,
	    scroll: {
	      type: Boolean,
	      default: true
	    }
	  },
	  created: function created() {
	    if (typeof this.value !== 'undefined') {
	      this.currentValue = this.value;
	    }
	  },
	
	  watch: {
	    value: function value(val) {
	      this.currentValue = val;
	    },
	    currentValue: function currentValue(val) {
	      this.$emit(val ? 'on-show' : 'on-hide');
	      this.$emit('input', val);
	    }
	  },
	  data: function data() {
	    return {
	      currentValue: false
	    };
	  },
	
	  methods: {
	    onTouchMove: function onTouchMove(event) {
	      !this.scroll && event.preventDefault();
	    }
	  }
	};

/***/ },
/* 621 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    leftOptions: {
	      type: Object,
	      default: function _default() {
	        return {
	          showBack: true,
	          backText: 'Back',
	          preventGoBack: false
	        };
	      }
	    },
	    title: String,
	    transition: String,
	    rightOptions: {
	      type: Object,
	      default: function _default() {
	        return {
	          showMore: false
	        };
	      }
	    }
	  },
	  methods: {
	    onClickBack: function onClickBack() {
	      if (this.leftOptions.preventGoBack) {
	        this.$emit('on-click-back');
	      } else {
	        window.history.back();
	      }
	    }
	  }
	};

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(2);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _lodash = __webpack_require__(599);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ACTION_EVENTS = ['legendselectchanged', 'legendselected', 'legendunselected', 'datazoom', 'datarangeselected', 'timelinechanged', 'timelineplaychanged', 'restore', 'dataviewchanged', 'magictypechanged', 'geoselectchanged', 'geoselected', 'geounselected', 'pieselectchanged', 'pieselected', 'pieunselected', 'mapselectchanged', 'mapselected', 'mapunselected', 'axisareaselected', 'brush', 'brushselected'];
	
	var MOUSE_EVENTS = ['click', 'dblclick', 'mouseover', 'mouseout', 'mousedown', 'mouseup', 'globalout'];
	
	exports.default = {
	  props: {
	    options: Object,
	    theme: String,
	    initOptions: Object,
	    group: String,
	    autoResize: Boolean
	  },
	  data: function data() {
	    return {
	      chart: null
	    };
	  },
	
	  computed: {
	    width: {
	      cache: false,
	      getter: function getter() {
	        return this.chart.getWidth();
	      }
	    },
	    height: {
	      cache: false,
	      getter: function getter() {
	        return this.chart.getHeight();
	      }
	    },
	    isDisposed: {
	      cache: false,
	      getter: function getter() {
	        return this.chart.isDisposed();
	      }
	    }
	  },
	  watch: {
	    options: {
	      handler: function handler(options) {
	        this.chart.setOption(options, true);
	      },
	
	      deep: true
	    },
	    group: {
	      handler: function handler(group) {
	        this.chart.group = group;
	      }
	    }
	  },
	  methods: {
	    mergeOptions: function mergeOptions(options) {
	      this.chart.setOption(options);
	    },
	    resize: function resize(options) {
	      this.chart.resize(options);
	    },
	    dispatchAction: function dispatchAction(payload) {
	      this.chart.dispatchAction(payload);
	    },
	    convertToPixel: function convertToPixel() {
	      var _chart;
	
	      return (_chart = this.chart).convertToPixel.apply(_chart, arguments);
	    },
	    convertFromPixel: function convertFromPixel() {
	      var _chart2;
	
	      return (_chart2 = this.chart).convertFromPixel.apply(_chart2, arguments);
	    },
	    containPixel: function containPixel() {
	      var _chart3;
	
	      return (_chart3 = this.chart).containPixel.apply(_chart3, arguments);
	    },
	    showLoading: function showLoading() {
	      var _chart4;
	
	      (_chart4 = this.chart).showLoading.apply(_chart4, arguments);
	    },
	    hideLoading: function hideLoading() {
	      this.chart.hideLoading();
	    },
	    getDataURL: function getDataURL(options) {
	      return this.chart.getDataURL(options);
	    },
	    getConnectedDataURL: function getConnectedDataURL(options) {
	      return this.chart.getConnectedDataURL(options);
	    },
	    clear: function clear() {
	      this.chart.clear();
	    },
	    dispose: function dispose() {
	      this.chart.dispose();
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var chart = _echarts2.default.init(this.$el, this.theme, this.initOptions);
	
	    chart.setOption(this.options);
	
	    ACTION_EVENTS.forEach(function (event) {
	      chart.on(event, function (params) {
	        _this.$emit(event, params);
	      });
	    });
	
	    MOUSE_EVENTS.forEach(function (event) {
	      chart.on(event, function (params) {
	        _this.$emit('chart' + event, params);
	      });
	    });
	
	    if (this.autoResize) {
	      this.__resizeHanlder = (0, _lodash2.default)(function () {
	        chart.resize();
	      }, 100, { leading: true });
	      window.addEventListener('resize', this.__resizeHanlder);
	    }
	
	    this.chart = chart;
	  },
	  connect: function connect(group) {
	    if (typeof group !== 'string') {
	      group = group.map(function (chart) {
	        return chart.chart;
	      });
	    }
	    _echarts2.default.connect(group);
	  },
	  disconnect: function disconnect(group) {
	    _echarts2.default.disconnect(group);
	  },
	  registerMap: function registerMap() {
	    _echarts2.default.registerMap.apply(_echarts2.default, arguments);
	  },
	  registerTheme: function registerTheme() {
	    _echarts2.default.registerTheme.apply(_echarts2.default, arguments);
	  }
	};

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _index = __webpack_require__(245);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    ViewBox: _index2.default
	  }
	};

/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(597);
	
	var _index = __webpack_require__(247);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _tab = __webpack_require__(130);
	
	var _tab2 = _interopRequireDefault(_tab);
	
	var _tabItem = __webpack_require__(129);
	
	var _tabItem2 = _interopRequireDefault(_tabItem);
	
	var _index3 = __webpack_require__(126);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _swiper = __webpack_require__(128);
	
	var _swiper2 = _interopRequireDefault(_swiper);
	
	var _swiperItem = __webpack_require__(127);
	
	var _swiperItem2 = _interopRequireDefault(_swiperItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var list = function list() {
	  return ['成交价格', '成交量', '户型分布'];
	};
	
	exports.default = {
	  data: function data() {
	    return {
	      list2: list(),
	      transitionName: 'slide-left',
	      demo2: '成交价格',
	      index: 0
	    };
	  },
	
	  watch: {
	    '$route': function $route(to, from) {
	      var toDepth = to.path.split('/').length;
	      var fromDepth = from.path.split('/').length;
	      this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left';
	    }
	  },
	  mounted: function mounted() {
	    console.log("mounted");
	  },
	  created: function created() {
	    console.debug(">>> home body state jw:%o", this.$store.state.jw);
	    console.debug(">>> home body after state type:%s", this.$store.state.jw.type);
	    console.debug(">>> detail head state state:%o", this.$store.state);
	    console.log("created currentRoute:%o", this.$root.currentRoute);
	  },
	
	  methods: {
	    submit: function submit() {
	      console.log("submit");
	    },
	    goHome: function goHome() {
	      console.log("goHome");
	      this.$router.push({ path: '/', query: { type: this.$store.state.jw.type } });
	    },
	    handler: function handler(item) {
	      console.log("handler click ");
	      console.log("list:%o", this.list2);
	
	      switch (item) {
	        case this.list2[1]:
	          console.log(item);
	          this.$router.push({ path: '/detail/qty' });
	          break;
	        case this.list2[2]:
	          console.log(item);
	          this.$router.push({ path: '/detail/type' });
	          break;
	        default:
	          console.log(item);
	          this.$router.push({ path: '/detail/' });
	      }
	    }
	  },
	  components: {
	    XHeader: _index2.default,
	    Tab: _tab2.default,
	    TabItem: _tabItem2.default,
	    Sticky: _index4.default,
	    Swiper: _swiper2.default,
	    SwiperItem: _swiperItem2.default
	  }
	};

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _extends2 = __webpack_require__(83);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _auth = __webpack_require__(40);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _line = __webpack_require__(602);
	
	var _line2 = _interopRequireDefault(_line);
	
	var _vuex = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {},
	  data: function data() {
	    return {
	      openid: '',
	      token: '',
	      community: '',
	      respData: {},
	      reqApiDataUrl: null,
	      reqType: null,
	      dd: null,
	      line: _line2.default
	    };
	  },
	
	  computed: (0, _vuex.mapState)({}),
	  beforeCreate: function beforeCreate() {
	    console.log("beforeCreate...");
	  },
	  created: function created() {
	    console.debug(">>>Detail Price state state:%o", this.$store.state);
	    console.log("created...");
	    console.log('get openid:%s', _auth2.default.getOpenid());
	    console.log('get token:%s', _auth2.default.getToken());
	    console.log("route.query.cm:%s", this.$route.query.cm);
	    var cm = _auth2.default.getCm();
	    var newcm = this.$route.query.cm;
	    console.debug("newcm:%s, cm:%s", newcm, cm);
	    if (typeof this.$route.query.cm != "undefined" && cm != newcm) {
	      console.debug("update new cm");
	      _auth2.default.setCm(newcm);
	
	      _auth2.default.clearDetailData();
	      cm = newcm;
	
	      this.community = cm;
	      console.debug("reqApiData");
	      this.openid = _auth2.default.getOpenid();
	      this.token = _auth2.default.getToken();
	      this.reqApiData(this.openid, this.token, this.community);
	    } else {
	      this.community = cm;
	      this.dd = _auth2.default.getDetailData();
	      console.debug("else dd:%o", this.dd);
	      this.load();
	    }
	
	    if (typeof this.$route.query.type != "undefined") {
	      this.reqType = this.$route.query.type;
	      console.log("reqType:%s", this.reqType);
	      _auth2.default.setCmType(this.reqType);
	    }
	  },
	  beforeMount: function beforeMount() {
	    console.log("beforeMount...");
	  },
	  mounted: function mounted() {
	    console.log("mounted...");
	  },
	
	  methods: (0, _extends3.default)({}, (0, _vuex.mapMutations)(['updateData', 'clearData']), {
	    load: function load() {
	      var data = this.dd;
	      console.log("data:%o", data);
	      if (typeof data === "undefined" || typeof data.price === "undefined" || typeof data.bj_price === "undefined") {
	        console.error("input data error : " + data);
	        return;
	      }
	      console.log("data:%o", data);
	      var price = data.price;
	      var bj_price = data.bj_price;
	
	
	      console.log("load...price:%o", price);
	      var at = [];
	      var as = [];
	      for (var key in price) {
	        var value = price[key];
	        at.push(key);
	        as.push(price[key]);
	      }
	
	      var bat = [];
	      var bas = [];
	      for (var _key in bj_price) {
	        var _value = bj_price[_key];
	        bat.push(_key);
	        bas.push(bj_price[_key]);
	      }
	
	      var n = [];
	
	      n.push(this.community);
	      n.push("北京");
	      console.log("n:%o", n);
	      var asyncData = {
	        name: n,
	        categories: at,
	        data: as
	      };
	
	      var bjasyncData = {
	        categories: bat,
	        data: bas
	      };
	
	      console.log("load...asyncData:%o", asyncData);
	      console.log("load...bjasyncData:%o", bjasyncData);
	
	      console.debug("$refs:%o", this.$refs);
	
	      this.$refs.line.mergeOptions({
	        legend: {
	          data: asyncData.name
	        },
	        yAxis: {
	          data: asyncData.categories
	        },
	        series: [{
	          name: asyncData.name[0],
	          data: asyncData.data
	        }, {
	          name: "北京",
	          data: bjasyncData.data
	        }]
	      });
	    },
	    reqApiData: function reqApiData(openid, token, community) {
	      var _this = this;
	
	      console.log("openid:%s, token:%s, community:%s", openid, token, community);
	      var reqType = _auth2.default.getCmType();
	      var reqHouseAreaUrl = null;
	      var req_data = null;
	      console.debug("reqType:%s, typeof:%s", reqType, typeof reqType === 'undefined' ? 'undefined' : (0, _typeof3.default)(reqType));
	      switch (reqType) {
	        case '1':
	          console.debug("bussiness deal");
	          req_data = { openid: openid, token: token, bizcycle: community };
	          reqHouseAreaUrl = 'http://alphago.chemucao.cn/real/api/index.php/bizcycle/deal';
	          break;
	        case '2':
	          console.debug("district deal");
	          req_data = { openid: openid, token: token, district: community };
	          reqHouseAreaUrl = 'http://alphago.chemucao.cn/real/api/index.php/district/deal';
	          break;
	        case '3':
	          console.debug("city deal");
	          req_data = { openid: openid, token: token, city: community };
	          reqHouseAreaUrl = 'http://alphago.chemucao.cn/real/api/index.php/city/deal';
	          break;
	        case '0':
	        default:
	          console.debug("nearby deal");
	          req_data = { openid: openid, token: token, community: community };
	          reqHouseAreaUrl = 'http://alphago.chemucao.cn/real/api/index.php/community/deal';
	          break;
	      }
	      var url = reqHouseAreaUrl;
	      console.log("reqHouseArea url:%s", url);
	      this.$http.post(url, req_data).then(function (response) {
	        console.log("PASS! response:%o", response);
	        console.log("status:%s", response.status);
	        console.log("statusText:%s", response.statusText);
	        console.log("Expires: %s", response.headers.get('Expires'));
	        console.log("body: %o", response.body);
	        _this.respData = response.body.data;
	
	        _auth2.default.setDetailData(response.body.data);
	
	        _this.dd = _auth2.default.getDetailData();
	        console.log("dd:%o", _this.dd);
	        if (_this.reqType === '0') {
	          console.debug("bussiness area");
	          console.log("coin: %d", response.body.data.coin);
	          _auth2.default.setCoins(response.body.data.coin);
	        }
	        _this.load();
	      }, function (response) {
	        console.error("FAIL!!! response:%o", response);
	      });
	    }
	  })
	};

/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Main = __webpack_require__(84);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _auth = __webpack_require__(40);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _bar = __webpack_require__(601);
	
	var _bar2 = _interopRequireDefault(_bar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    var legend_data = ['1', '2', '3', '4', '5'];
	    var series_data = [{ "value": "154", "name": "1" }, { "value": "576", "name": "2" }, { "value": "70", "name": "3" }, { "value": "12", "name": "4" }, { "value": "2", "name": "5" }];
	
	    return {
	
	      openid: '',
	      token: '',
	      community: '',
	      respData: {},
	      bar3: _bar2.default,
	
	      line: {
	        title: {
	          text: '成交价格',
	          left: 'center',
	          textStyle: {
	            color: '#999'
	          }
	        },
	        tooltip: {
	          trigger: 'axis'
	        },
	        legend: {
	          top: 25,
	          data: ['phpdata', '北京']
	        },
	        grid: {
	          left: '3%',
	          right: '4%',
	          bottom: '3%',
	          containLabel: true
	        },
	        toolbox: {
	          feature: {
	            dataZoom: { yAxisIndex: 'none' },
	            dataView: { readOnly: false },
	            saveAsImage: {}
	          }
	        },
	        xAxis: {
	          type: 'category',
	          boundaryGap: true,
	          data: []
	        },
	        yAxis: {
	          type: 'value'
	        },
	        series: [{
	          name: 'phpdata',
	          type: 'line',
	          data: ['phpdata']
	        }, {
	          name: '北京',
	          type: 'line',
	          data: ['phpdata']
	        }]
	      },
	
	      bar2: {
	
	        baseOption: {
	          title: {
	            text: '成交数量',
	            subtext: '数据来自网络'
	          },
	          tooltip: {
	            trigger: 'axis'
	          },
	          legend: {
	            orient: 'vertical',
	            data: ['phpdata', '北京']
	          },
	          grid: {
	            show: true,
	            left: '1%',
	            right: '1%',
	
	            containLabel: true
	          },
	          toolbox: {
	            feature: {
	              dataZoom: { yAxisIndex: 'none' },
	              dataView: { readOnly: false },
	              saveAsImage: {}
	            }
	          },
	          xAxis: {
	            type: 'value',
	            scale: true,
	            position: 'top'
	          },
	          yAxis: {
	            type: 'category',
	            inverse: true,
	            boundaryGap: true,
	            data: ['phpdata']
	          },
	          series: [{
	            name: 'phpdata',
	            type: 'bar',
	            data: ['phpdata'],
	            markPoint: {
	              data: [{ type: 'max', name: '最大值' }, { type: 'min', name: '最小值' }]
	            },
	            markLine: {
	              data: [{ type: 'average', name: '平均值' }]
	            }
	          }, {
	            name: '北京',
	            type: 'bar',
	            data: ['phpdata']
	          }]
	        },
	        media: [{
	          option: {
	            grid: {
	              show: true,
	              left: '1%',
	              right: '1%',
	              bottom: '1%',
	              containLabel: true
	            }
	          }
	        }, {
	          query: {
	            maxWidth: 320 },
	          option: {
	            grid: {
	              show: true,
	              left: '1%',
	              right: '1%',
	              bottom: '30%',
	              containLabel: true
	            }
	          }
	        }]
	
	      },
	      bar: {
	        title: {
	          text: '成交数量',
	          subtext: '数据来自网络'
	        },
	        tooltip: {
	          trigger: 'axis'
	        },
	        legend: {
	          orient: 'vertical',
	          data: ['phpdata', '北京']
	        },
	        grid: {
	          show: true,
	          left: '1%',
	          right: '1%',
	
	          containLabel: true
	        },
	        toolbox: {
	          feature: {
	            dataZoom: { yAxisIndex: 'none' },
	            dataView: { readOnly: false },
	            saveAsImage: {}
	          }
	        },
	        xAxis: {
	          type: 'value',
	          scale: true,
	          position: 'top'
	        },
	        yAxis: {
	          type: 'category',
	          inverse: true,
	          boundaryGap: true,
	          data: ['phpdata']
	        },
	        series: [{
	          name: 'phpdata',
	          type: 'bar',
	          data: ['phpdata'],
	          markPoint: {
	            data: [{ type: 'max', name: '最大值' }, { type: 'min', name: '最小值' }]
	          },
	          markLine: {
	            data: [{ type: 'average', name: '平均值' }]
	          }
	        }, {
	          name: '北京',
	          type: 'bar',
	          data: ['phpdata']
	        }]
	      }
	
	    };
	  },
	
	  methods: {
	    load: function load() {
	      console.log("this.respData:%o", this.respData);
	      var count = this.respData.count;
	      var bj_count = this.respData.bj_count;
	      var brief = this.respData.brief;
	
	      console.log("updateChart...count:%o", count);
	      var at = [];
	      var as = [];
	      for (var key in count) {
	        var value = count[key];
	        at.push(key);
	        as.push(value);
	      }
	
	      console.log("updateChart...bj_count:%o", bj_count);
	      var bat = [];
	      var bas = [];
	      for (var _key in bj_count) {
	        var _value = bj_count[_key];
	        bat.push(_key);
	        bas.push(_value);
	      }
	
	      var n = [];
	      n.push(brief.name);
	      n.push("北京");
	      console.log("n:%o", n);
	      var asyncData = {
	        name: n,
	        categories: at,
	        data: as
	      };
	
	      var bjasyncData = {
	        categories: bat,
	        data: bas
	      };
	
	      console.log("load...asyncData:%o", asyncData.data);
	      console.log("load...bjasyncData:%o", bjasyncData.data);
	
	      this.$refs.bar.mergeOptions({
	        legend: {
	          data: asyncData.name
	        },
	        yAxis: {
	          data: asyncData.categories
	        },
	        series: [{
	          name: asyncData.name[0],
	          data: asyncData.data
	        }, {
	          name: "北京",
	          data: bjasyncData.data
	        }]
	      });
	    },
	
	    reqApiData: function reqApiData(openid, token, community) {
	      var _this = this;
	
	      console.log("openid:%s, token:%s, community:%s", openid, token, community);
	      var reqHouseAreaUrl = 'http://alphago.chemucao.cn/real/api/index.php/community/deal';
	      var url = reqHouseAreaUrl;
	      var req_data = { openid: openid, token: token, community: community };
	      console.log("reqHouseArea url:%s", url);
	      this.$http.post(url, req_data).then(function (response) {
	        console.log("PASS! response:%o", response);
	        console.log("status:%s", response.status);
	        console.log("statusText:%s", response.statusText);
	        console.log("Expires: %s", response.headers.get('Expires'));
	        console.log("body: %o", response.body);
	        _this.respData = response.body.data;
	        console.log("coin: %d", response.body.data.coin);
	        _auth2.default.setCoins(response.body.data.coin);
	        _this.load();
	      }, function (response) {
	        console.error("FAIL!!! response:%o", response);
	      });
	    },
	    updateChart: function updateChart(data) {
	      data = [{ "count": "154", "bedroom": "1" }, { "count": "576", "bedroom": "2" }, { "count": "70", "bedroom": "3" }, { "count": "12", "bedroom": "4" }, { "count": "2", "bedroom": "5" }];
	      console.log("updateChart...data:%o", data);
	      var at = new Array();
	      var as = new Array();
	      var asyncData = {
	        categories: at,
	        data: as
	      };
	
	      for (var x in data) {
	        console.log("x:%s, data:%o", x, data[x]);
	        var tn = data[x]["bedroom"] + "居室";
	        at.push(tn);
	        var ass = '{"value":"' + data[x]["count"] + '","name":"' + tn + '"}';
	        as.push(ass);
	      }
	      console.log("at:%o, as:%o", at, as);
	      console.log("this.$refs.pie:%o", this.$refs.pie);
	      return asyncData;
	    }
	  },
	  beforeCreate: function beforeCreate() {
	    console.log("beforeCreate...");
	  },
	  created: function created() {
	    console.log("created...");
	    console.log('get openid:%s', _auth2.default.getOpenid());
	    console.log('get community:%s', _auth2.default.getCm());
	    console.log('get token:%s', _auth2.default.getToken());
	    console.log("route.query.cm:%s", this.$route.query.cm);
	    if (typeof this.$route.query.cm != "undefined") {
	      var cm = this.$route.query.cm;
	      console.log("cm:%s", cm);
	      _auth2.default.setCm(cm);
	    }
	    this.openid = _auth2.default.getOpenid();
	    this.token = _auth2.default.getToken();
	    this.community = _auth2.default.getCm();
	    console.log("community:%s", this.community);
	    this.reqApiData(this.openid, this.token, this.community);
	  },
	  beforeMount: function beforeMount() {
	    console.log("beforeMount...");
	  },
	  mounted: function mounted() {
	    console.log("mounted...");
	  },
	  beforeUpdate: function beforeUpdate() {
	    console.log("beforeUpdate...");
	  },
	  updated: function updated() {
	    console.log("updated...");
	  },
	  activated: function activated() {
	    console.log("activated...");
	  },
	  deactivated: function deactivated() {
	    console.log("deactivated...");
	  },
	  beforeDestory: function beforeDestory() {
	    console.log("beforeDestory...");
	  },
	  destroyed: function destroyed() {
	    console.log("destroyed...");
	  },
	
	  components: {
	    MainLayout: _Main2.default
	  }
	
	};

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _extends2 = __webpack_require__(83);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _auth = __webpack_require__(40);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _vuex = __webpack_require__(41);
	
	var _index = __webpack_require__(124);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _tab = __webpack_require__(130);
	
	var _tab2 = _interopRequireDefault(_tab);
	
	var _tabItem = __webpack_require__(129);
	
	var _tabItem2 = _interopRequireDefault(_tabItem);
	
	var _index3 = __webpack_require__(126);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _index5 = __webpack_require__(62);
	
	var _index6 = _interopRequireDefault(_index5);
	
	var _index7 = __webpack_require__(246);
	
	var _index8 = _interopRequireDefault(_index7);
	
	var _swiper = __webpack_require__(128);
	
	var _swiper2 = _interopRequireDefault(_swiper);
	
	var _swiperItem = __webpack_require__(127);
	
	var _swiperItem2 = _interopRequireDefault(_swiperItem);
	
	var _echarts = __webpack_require__(103);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	__webpack_require__(598);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var list = function list() {
	  return ['< 返回', '成交价格', '成交量', '户型分布'];
	};
	
	exports.default = {
	  components: {
	    Loading: _index2.default,
	    Tab: _tab2.default,
	    TabItem: _tabItem2.default,
	    Sticky: _index4.default,
	    Divider: _index6.default,
	    XButton: _index8.default,
	    Swiper: _swiper2.default,
	    SwiperItem: _swiperItem2.default
	  },
	  data: function data() {
	    return {
	      show1: true,
	      text1: '加载中',
	
	      list2: list(),
	      demo2: '成交价格',
	      index: 1,
	      openid: '',
	      token: '',
	      community: '',
	      respData: {},
	      reqApiDataUrl: null,
	      reqType: null,
	      chart: {}
	    };
	  },
	
	  computed: (0, _vuex.mapState)({
	    detailData: function detailData(state) {
	      return state.jw.detailData;
	    }
	  }),
	  mounted: function mounted() {
	    console.log(">>>Detail Price state state:%o", this.$store.state);
	    console.log("created...");
	    console.log('get openid:%s', _auth2.default.getOpenid());
	    console.log('get token:%s', _auth2.default.getToken());
	    console.log("route.query.cm:%s", this.$route.query.cm);
	    var cm = _auth2.default.getCm();
	    var newcm = this.$route.query.cm;
	    console.log("newcm:%s, cm:%s", newcm, cm);
	    if (typeof this.$route.query.cm != "undefined" && cm != newcm) {
	      console.log("update new cm");
	      _auth2.default.setCm(newcm);
	      cm = newcm;
	    }
	
	    this.community = cm;
	    console.log("reqApiData");
	    this.openid = _auth2.default.getOpenid();
	    this.token = _auth2.default.getToken();
	    this.reqApiData(this.openid, this.token, this.community);
	
	    if (typeof this.$route.query.type != "undefined") {
	      this.reqType = this.$route.query.type;
	      console.log("reqType:%s", this.reqType);
	      _auth2.default.setCmType(this.reqType);
	    }
	  },
	
	  methods: (0, _extends3.default)({}, (0, _vuex.mapMutations)(['updateData', 'clearData']), {
	    barHandler: function barHandler(item) {
	      switch (item) {
	        case this.list2[0]:
	          console.log("return home");
	          this.$router.push({ path: '/', query: { type: this.$store.state.jw.type } });
	          break;
	        case this.list2[1]:
	          break;
	        case this.list2[2]:
	          break;
	        default:
	          break;
	      }
	    },
	    drawbar: function drawbar(id, priceData, bjPriceData) {
	      this.chart = _echarts2.default.init(document.getElementById(id));
	
	      this.chart.setOption({
	        baseOption: {
	          title: {
	            text: '成交量',
	            subtext: '数据来自网络'
	          },
	          tooltip: {
	            trigger: 'axis'
	          },
	          legend: {
	            orient: 'vertical',
	            data: [priceData.name, '北京']
	          },
	          grid: {
	            show: true,
	            left: '1%',
	            right: '1%',
	
	            containLabel: true
	          },
	          toolbox: {
	            feature: {
	              dataView: { readOnly: false },
	              saveAsImage: {}
	            }
	          },
	          xAxis: {
	            type: 'value',
	            scale: true,
	            position: 'top'
	          },
	          yAxis: {
	            type: 'category',
	            inverse: true,
	            boundaryGap: true,
	            data: priceData.categories
	          },
	          series: [{
	            name: priceData.name,
	            type: 'bar',
	            data: priceData.data,
	            markPoint: {
	              data: [{ type: 'max', name: '最大值' }, { type: 'min', name: '最小值' }]
	            },
	            markLine: {
	              data: [{ type: 'average', name: '平均值' }]
	            }
	          }, {
	            name: '北京',
	            type: 'bar',
	            data: bjPriceData.data
	          }]
	        },
	        media: [{
	          option: {
	            grid: {
	              show: true,
	              left: '1%',
	              right: '1%',
	              bottom: '1%',
	              containLabel: true
	            }
	          }
	        }, {
	          query: {
	            maxWidth: 320 },
	          option: {
	            grid: {
	              show: true,
	              left: '1%',
	              right: '1%',
	              bottom: '30%',
	              containLabel: true
	            }
	          }
	        }]
	
	      });
	    },
	    drawpie: function drawpie(id, centery, bedroom, bjbedroom) {
	      console.log("id:%s, centery:%s, bedroom:%o, bjbedroom:%o", id, centery, bedroom, bjbedroom);
	      this.chart = _echarts2.default.init(document.getElementById(id));
	      this.chart.setOption({
	
	        baseOption: {
	          title: {
	            text: '户型分布',
	            subtext: '数据来自网络'
	          },
	          tooltip: {
	            trigger: 'item',
	            formatter: "{a} <br/>{b} : {c} ({d}%)"
	          },
	          legend: {
	            data: bedroom.categories
	          },
	          toolbox: {
	            show: true,
	            feature: {
	              mark: { show: true },
	              dataView: { show: true, readOnly: false },
	              magicType: {
	                show: true,
	                type: ['pie', 'funnel']
	              },
	              saveAsImage: { show: true }
	            }
	          },
	          calculable: true,
	          series: [{
	            name: '半径模式',
	            type: 'pie',
	            roseType: 'radius',
	            label: {
	              normal: {
	                show: true
	              },
	              emphasis: {
	                show: true
	              }
	            },
	            lableLine: {
	              normal: {
	                show: true
	              },
	              emphasis: {
	                show: true
	              }
	            },
	            data: bedroom.data
	          }, {
	            name: '面积模式',
	            type: 'pie',
	            roseType: 'area',
	            data: bjbedroom.data
	          }]
	        },
	        media: [{
	          option: {
	            legend: {
	              right: 'center',
	              orient: 'horizontal'
	            },
	            series: [{
	              radius: ['10%', '30%'],
	              center: ['50%', '30%']
	            }, {
	              radius: ['10%', '30%'],
	              center: ['50%', '65%']
	            }]
	          }
	        }]
	
	      });
	    },
	    drawLine: function drawLine(id, linedata, bjlinedata) {
	      console.log("drawline> id:%s, linedata:%o, bjlinedata:%o", id, linedata, bjlinedata);
	      this.chart = _echarts2.default.init(document.getElementById(id));
	      this.chart.setOption({
	
	        baseOption: {
	          title: {
	            text: '成交价格',
	            subtext: '数据来自网络'
	          },
	          tooltip: {
	            trigger: 'axis'
	          },
	          legend: {
	            orient: 'vertical',
	            data: [linedata.name, '北京']
	          },
	          grid: {
	            show: true,
	            left: '1%',
	            right: '1%',
	            containLabel: true
	          },
	          toolbox: {
	            feature: {
	              dataView: { readOnly: false },
	              saveAsImage: {}
	            }
	          },
	          xAxis: {
	            type: 'value',
	            scale: true,
	            position: 'top'
	          },
	          yAxis: {
	            type: 'category',
	            inverse: true,
	            boundaryGap: true,
	            data: linedata.categories
	          },
	          series: [{
	            name: linedata.name,
	            type: 'line',
	            data: linedata.data,
	            markPoint: {
	              data: [{ type: 'max', name: '最大值' }, { type: 'min', name: '最小值' }]
	            },
	            markLine: {
	              data: [{ type: 'average', name: '平均值' }]
	            }
	          }, {
	            name: '北京',
	            type: 'line',
	            data: bjlinedata.data
	          }]
	        },
	        media: [{
	          option: {
	            grid: {
	              show: true,
	              left: '1%',
	              right: '1%',
	              bottom: '1%',
	              containLabel: true
	            }
	          }
	        }, {
	          query: {
	            maxWidth: 320 },
	          option: {
	            grid: {
	              show: true,
	              left: '1%',
	              right: '1%',
	              bottom: '30%',
	              containLabel: true
	            }
	          }
	        }]
	
	      });
	    },
	    transform: function transform(obj, name, type) {
	      console.log("obj:%o, name:%s, type:%d", obj, name, type);
	      var to = new Object();
	      var at = [];
	      var as = [];
	      var key = '';
	      var value = '';
	      for (var item in obj) {
	        if (type === 1) {
	          key = obj[item]['bedroom'] + "居室";
	          value = obj[item]['count'];
	          value = { value: value, name: key };
	        } else {
	          key = item;
	          value = obj[item];
	        }
	        at.push(key);
	        as.push(value);
	      }
	      to.categories = at;
	      to.data = as;
	      to.name = name;
	      return to;
	    },
	
	    load: function load(data) {
	      console.log("data:%o", data);
	      if (typeof data === "undefined" || typeof data.price === "undefined") {
	        console.error("input data error : " + data);
	        return;
	      }
	      console.log("data:%o", data);
	
	      var brief_name = this.community;
	      var count = new Object();
	      var bjcount = new Object();
	      count = this.transform(data.count, brief_name, 0);
	      bjcount = this.transform(data.bj_count, '北京', 0);
	      console.log("load...count:%o", count);
	      console.log("load...bjcount:%o", bjcount);
	      this.drawbar('dealPrice', count, bjcount);
	
	      var price = new Object();
	      var bjprice = new Object();
	      price = this.transform(data.price, brief_name, 0);
	      bjprice = this.transform(data.bj_price, '北京', 0);
	      console.log("load...price:%o", price);
	      console.log("load...bjprice:%o", bjprice);
	      this.drawLine('dealQty', price, bjprice);
	
	      var bedroom = this.respData.bedroom;
	      var bj_bedroom = this.respData.bj_bedroom;
	      bedroom = this.transform(this.respData.bedroom, brief_name, 1);
	      bj_bedroom = this.transform(this.respData.bj_bedroom, '北京', 1);
	      console.log("load...bedroom:%o", bedroom);
	      console.log("load...bj_bedroom:%o", bj_bedroom);
	      this.drawpie('dealType', '60%', bedroom, bj_bedroom);
	    },
	    reqApiData: function reqApiData(openid, token, community) {
	      var _this = this;
	
	      console.log("openid:%s, token:%s, community:%s", openid, token, community);
	      var reqType = _auth2.default.getCmType();
	      var reqHouseAreaUrl = null;
	      var req_data = null;
	      console.log("reqType:%s, typeof:%s", reqType, typeof reqType === 'undefined' ? 'undefined' : (0, _typeof3.default)(reqType));
	      switch (reqType) {
	        case '1':
	          console.log("bussiness deal");
	          req_data = { openid: openid, token: token, bizcycle: community };
	          reqHouseAreaUrl = 'http://alphago.chemucao.cn/real/api/index.php/bizcycle/deal';
	          break;
	        case '2':
	          console.log("district deal");
	          req_data = { openid: openid, token: token, district: community };
	          reqHouseAreaUrl = 'http://alphago.chemucao.cn/real/api/index.php/district/deal';
	          break;
	        case '3':
	          console.log("city deal");
	          req_data = { openid: openid, token: token, city: community };
	          reqHouseAreaUrl = 'http://alphago.chemucao.cn/real/api/index.php/city/deal';
	          break;
	        case '0':
	        default:
	          console.log("nearby deal");
	          req_data = { openid: openid, token: token, community: community };
	          reqHouseAreaUrl = 'http://alphago.chemucao.cn/real/api/index.php/community/deal';
	          break;
	      }
	      var url = reqHouseAreaUrl;
	      console.log("reqHouseArea url:%s", url);
	      this.$http.post(url, req_data).then(function (response) {
	        console.log("PASS! response:%o", response);
	        console.log("status:%s", response.status);
	        console.log("statusText:%s", response.statusText);
	        console.log("Expires: %s", response.headers.get('Expires'));
	        console.log("body: %o", response.body);
	        _this.respData = response.body.data;
	        if (_this.reqType === '0') {
	          console.log("bussiness area");
	          console.log("coin: %d", response.body.data.coin);
	          _auth2.default.setCoins(response.body.data.coin);
	        }
	        _this.load(_this.respData);
	        _this.show1 = false;
	      }, function (response) {
	        console.error("FAIL!!! response:%o", response);
	      });
	    }
	  })
	};

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _auth = __webpack_require__(40);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _pie = __webpack_require__(603);
	
	var _pie2 = _interopRequireDefault(_pie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {},
	  data: function data() {
	    return {
	      openid: '',
	      token: '',
	      community: '',
	      respData: {},
	      reqApiDataUrl: null,
	      reqType: null,
	      pie3: _pie2.default
	    };
	  },
	  beforeCreate: function beforeCreate() {
	    console.log("beforeCreate...");
	  },
	  created: function created() {
	    console.debug(">>>Detail Price state state:%o", this.$store.state);
	    console.log("created...");
	    console.log('get openid:%s', _auth2.default.getOpenid());
	    console.log('get token:%s', _auth2.default.getToken());
	    console.log("route.query.cm:%s", this.$route.query.cm);
	    if (typeof this.$route.query.cm != "undefined") {
	      var cm = this.$route.query.cm;
	      console.log("cm:%s", cm);
	      _auth2.default.setCm(cm);
	    }
	    if (typeof this.$route.query.type != "undefined") {
	      this.reqType = this.$route.query.type;
	      console.log("reqType:%s", this.reqType);
	      _auth2.default.setCmType(this.reqType);
	    }
	    this.openid = _auth2.default.getOpenid();
	    this.token = _auth2.default.getToken();
	    this.community = _auth2.default.getCm();
	    console.log("community:%s", this.community);
	    this.reqApiData(this.openid, this.token, this.community);
	  },
	  beforeMount: function beforeMount() {
	    console.log("beforeMount...");
	  },
	  mounted: function mounted() {
	    console.log("mounted...");
	  },
	  beforeUpdate: function beforeUpdate() {
	    console.log("beforeUpdate...");
	  },
	  updated: function updated() {
	    console.log("updated...");
	  },
	  activated: function activated() {
	    console.log("activated...");
	  },
	  deactivated: function deactivated() {
	    console.log("deactivated...");
	  },
	  beforeDestory: function beforeDestory() {
	    console.log("beforeDestory...");
	  },
	  destroyed: function destroyed() {
	    console.log("destroyed...");
	  },
	
	  methods: {
	    load: function load() {
	      console.log("this.respData:%o", this.respData);
	      var bedroom = this.respData.bedroom;
	      var bj_bedroom = this.respData.bj_bedroom;
	
	
	      console.log("load...bedroom:%o", bedroom);
	      var at = [];
	      var as = [];
	      for (var key in bedroom) {
	        var name = bedroom[key]['bedroom'] + "居室";
	        var value = bedroom[key]['count'];
	        value = { value: value, name: name };
	        at.push(name);
	        as.push(value);
	        console.log("name:%s, value:%s", name, value);
	      }
	
	      console.log("load...bj_bedroom:%o", bj_bedroom);
	      var bat = [];
	      var bas = [];
	      for (var _key in bj_bedroom) {
	        var _name = bj_bedroom[_key]['bedroom'] + "居室";
	        var _value = bj_bedroom[_key]['count'];
	        _value = { value: _value, name: _name };
	        bat.push(_name);
	        bas.push(_value);
	        console.log("name:%s, value:%s", _name, _value);
	      }
	
	      var n = [];
	
	      n.push(this.community);
	      n.push("北京");
	      console.log("n:%o", n);
	      var asyncData = {
	        name: n,
	        categories: at,
	        data: as
	      };
	
	      var bjasyncData = {
	        categories: bat,
	        data: bas
	      };
	      console.log("load...asyncData:%o", asyncData);
	      console.log("load...bjasyncData:%o", bjasyncData);
	      this.$refs.pie.mergeOptions({
	        legend: {
	          data: asyncData.categories
	        },
	        series: [{
	          name: asyncData.name[0],
	          data: asyncData.data
	        }, {
	          name: asyncData.name[1],
	          data: bjasyncData.data
	        }]
	      });
	    },
	
	    reqApiData: function reqApiData(openid, token, community) {
	      var _this = this;
	
	      console.log("openid:%s, token:%s, community:%s", openid, token, community);
	      var reqType = _auth2.default.getCmType();
	      var reqHouseAreaUrl = null;
	      var req_data = null;
	      console.debug("reqType:%s, typeof:%s", reqType, typeof reqType === 'undefined' ? 'undefined' : (0, _typeof3.default)(reqType));
	      switch (reqType) {
	        case '1':
	          console.debug("bussiness deal");
	          req_data = { openid: openid, token: token, bizcycle: community };
	          reqHouseAreaUrl = 'http://alphago.chemucao.cn/real/api/index.php/bizcycle/deal';
	          break;
	        case '2':
	          console.debug("district deal");
	          req_data = { openid: openid, token: token, district: community };
	          reqHouseAreaUrl = 'http://alphago.chemucao.cn/real/api/index.php/district/deal';
	          break;
	        case '3':
	          console.debug("city deal");
	          req_data = { openid: openid, token: token, city: community };
	          reqHouseAreaUrl = 'http://alphago.chemucao.cn/real/api/index.php/city/deal';
	          break;
	        case '0':
	        default:
	          console.debug("nearby deal");
	          req_data = { openid: openid, token: token, community: community };
	          reqHouseAreaUrl = 'http://alphago.chemucao.cn/real/api/index.php/community/deal';
	          break;
	      }
	      var url = reqHouseAreaUrl;
	      console.log("reqHouseArea url:%s", url);
	      this.$http.post(url, req_data).then(function (response) {
	        console.log("PASS! response:%o", response);
	        console.log("status:%s", response.status);
	        console.log("statusText:%s", response.statusText);
	        console.log("Expires: %s", response.headers.get('Expires'));
	        console.log("body: %o", response.body);
	        _this.respData = response.body.data;
	        if (_this.reqType === '0') {
	          console.debug("bussiness area");
	          console.log("coin: %d", response.body.data.coin);
	          _auth2.default.setCoins(response.body.data.coin);
	        }
	        _this.load();
	      }, function (response) {
	        console.error("FAIL!!! response:%o", response);
	      });
	    }
	  }
	
	};

/***/ },
/* 629 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'hello',
	  data: function data() {
	    return {
	      msg: 'Welcome to Your Vue.js App'
	    };
	  }
	};

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _index = __webpack_require__(123);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(122);
	
	var _index4 = _interopRequireDefault(_index3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Group: _index2.default,
	    Cell: _index4.default
	  },
	  data: function data() {
	    return {
	      msg: 'Hello World!'
	    };
	  }
	};

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(83);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Main = __webpack_require__(84);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _weixinJsSdk = __webpack_require__(85);
	
	var _weixinJsSdk2 = _interopRequireDefault(_weixinJsSdk);
	
	var _auth = __webpack_require__(40);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _vuex = __webpack_require__(41);
	
	var _index = __webpack_require__(243);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(241);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _index5 = __webpack_require__(125);
	
	var _index6 = _interopRequireDefault(_index5);
	
	var _index7 = __webpack_require__(62);
	
	var _index8 = _interopRequireDefault(_index7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      show: false,
	      show_title: '提示',
	      show_content: '您的余额已不足，请充值后使用!',
	      btn_ok: '确认',
	      btn_cancel: '取消',
	      coins: 0,
	
	      value: '请输入小区名（查询一次仅需1钢蹦）',
	      subtitleMsg: '你可能感兴趣的小区',
	      lists: [],
	      token: '',
	      openid: '',
	      reqNearbyUrl: null,
	      reqHouseAreaUrl: null,
	      reqType: null,
	      community: ''
	    };
	  },
	
	  computed: (0, _vuex.mapState)({
	    pageType: function pageType(state) {
	      return state.jw.type;
	    },
	    detailData: function detailData(state) {
	      return state.jw.detailData;
	    }
	  }),
	  mounted: function mounted() {
	    console.log(">>> mounted, query:%o", this.$route.query);
	    if (this.$route.query.type != null) {
	      this.reqType = this.$route.query.type;
	    } else {
	      this.reqType = '0';
	    }
	    this.coins = parseInt(_auth2.default.getCoins());
	    console.debug("coins:%d", this.coins);
	  },
	  created: function created() {
	    console.log(">>> home body state jw:%o", this.$store.state.jw);
	    console.log("created currentRoute:%o", this.$root.currentRoute);
	    console.log("route.query.type:%s", this.$route.query.type);
	    if (this.$route.query.type === '1') {
	      console.log("bussiness area");
	      this.reqNearbyUrl = "http://alphago.chemucao.cn/real/api/index.php/bizcycle/nearby";
	      this.subtitleMsg = '你可能感兴趣的商圈';
	      this.value = '请输入商圈名（查询一次仅需1钢蹦）';
	      this.reqType = this.$route.query.type;
	    } else if (this.$route.query.type === '2') {
	      console.log("district area");
	      this.reqNearbyUrl = "http://alphago.chemucao.cn/real/api/index.php/district/nearby";
	      this.subtitleMsg = '你可能感兴趣的区县';
	      this.value = '请输入区县名（查询一次仅需1钢蹦）';
	      this.reqType = this.$route.query.type;
	    } else if (this.$route.query.type === '3') {
	      console.log("city area");
	      this.reqNearbyUrl = "http://alphago.chemucao.cn/real/api/index.php/city/deal";
	      this.subtitleMsg = '你可能感兴趣的城市';
	      this.value = '请输入城市名（查询一次仅需1钢蹦）';
	      this.reqType = this.$route.query.type;
	      this.updateType(this.reqType);
	      console.log(">>> home body after state type:%s", this.pageType);
	      this.community = '北京';
	      _auth2.default.setCm(this.community);
	      this.$router.push({ path: '/test', query: { cm: this.community, type: this.reqType } });
	    } else {
	      console.log("nearby area");
	      this.reqNearbyUrl = "http://alphago.chemucao.cn/real/api/index.php/community/nearby";
	      this.reqType = 0;
	    }
	    this.updateType(this.reqType);
	    console.log(">>> home body after state type:%s", this.pageType);
	    console.debug("detailData:%o", this.detailData);
	    var lat = _auth2.default.getLat();
	    var longt = _auth2.default.getLongt();
	    this.openid = _auth2.default.getOpenid();
	    this.token = _auth2.default.getToken();
	    this.reqNearby(this.openid, this.token, lat, longt);
	  },
	
	  methods: (0, _extends3.default)({}, (0, _vuex.mapMutations)(['updateType']), {
	    onCancel: function onCancel() {
	      console.log('on cancel');
	    },
	    onConfirm: function onConfirm() {
	      console.log('on confirm');
	    },
	    onHide: function onHide() {
	      console.log('on hide');
	    },
	    onShow: function onShow() {
	      console.log('on show');
	    },
	    showPlugin: function showPlugin() {
	      this.show = true;
	    },
	    showPluginAuto: function showPluginAuto() {
	      var _this = this;
	
	      this.showPlugin();
	      setTimeout(function () {
	        _this.show = false;
	      }, 3000);
	    },
	
	    reqNearby: function reqNearby(openid, token, latitude, longitude) {
	      var _this2 = this;
	
	      console.log("reqNearby: openid:%s, token:%s, latitude:%s, longitude:%s", openid, token, latitude, longitude);
	
	      var url = this.reqNearbyUrl;
	      var req_data = { openid: openid, token: token, latitude: latitude, longitude: longitude };
	      console.log("url:%s, req_data:%o", url, req_data);
	      this.$http.post(url, req_data).then(function (data) {
	        data = data.body;
	        console.log("successful data:%o", data);
	
	        var res_data = data.data.nearby;
	        console.log("res_data:%o", res_data);
	        if (data.code === 0) {
	          var od = [];
	
	          for (var p in res_data) {
	            od.push(res_data[p]["name"]);
	          }
	
	          _this2.lists = od;
	          console.log("list:%o", _this2.lists);
	        }
	      }, function (response) {
	        var msg = "wxPayReg failed!!!" + response;
	        console.error(msg);
	        alert(msg);
	      });
	    },
	    submit: function submit() {
	      if (this.coins < 1) {
	        console.debug("coins:%d", this.coins);
	        this.showPlugin();
	        return;
	      }
	      this.openid = _auth2.default.getOpenid();
	      this.token = _auth2.default.getToken();
	      console.log("openid:%s, token:%s, community:%s", this.openid, this.token, this.community);
	      this.reqHouseArea(this.openid, this.token, this.community);
	      _auth2.default.setCm(this.community);
	    },
	    updateCm: function updateCm(cm) {
	      console.log("update cm:%s", cm);
	      _auth2.default.setCm(cm);
	    },
	    reqHouseArea: function reqHouseArea(openid, token, community) {
	      var _this3 = this;
	
	      console.log("openid:%s, token:%s, community:%s", openid, token, community);
	
	      var req_data = null;
	      console.log("route.query.type:%s", this.$route.query.type);
	      if (this.$route.query.type === '1') {
	        console.log("bussiness area");
	        this.reqHouseAreaUrl = "http://alphago.chemucao.cn/real/api/index.php/bizcycle/deal";
	        req_data = { openid: openid, token: token, bizcycle: community };
	      } else if (this.$route.query.type === '2') {
	        console.log("district area");
	        this.reqHouseAreaUrl = "http://alphago.chemucao.cn/real/api/index.php/district/deal";
	        req_data = { openid: openid, token: token, district: community };
	      } else if (this.$route.query.type === '3') {
	        console.log("city area");
	        this.reqHouseAreaUrl = "http://alphago.chemucao.cn/real/api/index.php/city/deal";
	        req_data = { openid: openid, token: token, city: community };
	      } else {
	        console.log("nearby area");
	        this.reqHouseAreaUrl = "http://alphago.chemucao.cn/real/api/index.php/community/deal";
	        req_data = { openid: openid, token: token, community: community };
	      }
	
	      var url = this.reqHouseAreaUrl;
	      console.log("reqHouseArea url:%s", url);
	      this.$http.post(url, req_data).then(function (response) {
	        console.log("PASS! response:%o", response);
	        console.log("data:%o", response.body.data);
	        if (response.status === 200 && response.body.data.guess != null) {
	          var datalist = response.body.data.guess;
	
	          var od = [];
	
	          for (var p in datalist) {
	            od.push(datalist[p]["name"]);
	          }
	          _this3.lists = od;
	        }
	      }, function (response) {
	        console.error("FAIL!!! response:%o", response);
	      });
	    }
	  }),
	  components: {
	    Confirm: _index2.default,
	    Alert: _index4.default,
	    Search: _index6.default,
	    Divider: _index8.default,
	    MainLayout: _Main2.default
	  }
	};

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(209);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _weixinJsSdk = __webpack_require__(85);
	
	var _weixinJsSdk2 = _interopRequireDefault(_weixinJsSdk);
	
	var _auth = __webpack_require__(40);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _index = __webpack_require__(123);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(122);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _index5 = __webpack_require__(124);
	
	var _index6 = _interopRequireDefault(_index5);
	
	var _index7 = __webpack_require__(62);
	
	var _index8 = _interopRequireDefault(_index7);
	
	var _index9 = __webpack_require__(242);
	
	var _index10 = _interopRequireDefault(_index9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Loading: _index6.default,
	    Group: _index2.default,
	    Cell: _index4.default,
	    Card: _index10.default,
	    Divider: _index8.default
	  },
	  data: function data() {
	    return {
	      show1: true,
	      text1: '加载中',
	      transitionName: 'slide-left',
	
	      coins: 0,
	      name: "",
	      portrait: null,
	
	      reqWxJSSignUrl: 'http://alphago.chemucao.cn/real/api/index.php/jsapi/sign',
	      reqWxPaySignUrl: 'http://alphago.chemucao.cn/real/api/index.php/wxpay/jsapi',
	
	      wx_appId: null,
	      wx_timestamp: null,
	      wx_nonceStr: null,
	      wx_signature: null,
	
	      wxp_nonceStr: null,
	      wxp_package: null,
	      wxp_paySign: null,
	      wxp_signType: null,
	      wxp_timeStamp: null,
	
	      autopay: 0,
	      token: null,
	      openid: null,
	      community: ''
	    };
	  },
	  mounted: function mounted() {},
	  created: function created() {
	    console.log(">>> home head state state:%o", this.$store.state);
	    console.log("created currentRoute:%o", this.$root.currentRoute);
	    console.log(">>> route.query:%o", this.$route.query);
	    if (typeof this.$route.query.autopay != "undefined") {
	      this.autopay = this.$route.query.autopay;
	      console.log("autopay enable:%s", this.autopay);
	    }
	    var code = this.getParameterByName("code");
	    console.log("code:%s", code);
	    var state = this.getParameterByName("state");
	    console.log("state:%s", state);
	    this.loginUrl(code, state);
	  },
	
	  methods: {
	    getParameterByName: function getParameterByName(name) {
	      name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
	      var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
	          results = regex.exec(location.search);
	      return results == null ? "" : decodeURIComponent(results[1]);
	    },
	    loginUrl: function loginUrl(code, state) {
	      var _this = this;
	
	      if (code.length == 0) {
	        this.openid = _auth2.default.getOpenid();
	        this.coins = _auth2.default.getCoins();
	        this.name = _auth2.default.getName();
	        this.portrait = _auth2.default.getPortrait();
	        this.token = _auth2.default.getToken();
	        var as = "loginUrl! openid:" + this.openid + ", token:" + this.token;
	        console.log(as);
	        this.reqWxJSSign();
	
	        return;
	      }
	      if (state.length == 0) {
	        state = "gzh";
	      }
	      console.log("loginUrl: length code:%d, state:%d", code.length, state.length);
	      var url = "http://alphago.chemucao.cn/real/api/index.php/user/login";
	      var req_data = { code: code, state: state };
	      console.log("loginUrl url:%s, req_data:%o", url, req_data);
	      this.$http.post(url, req_data).then(function (res) {
	        console.log("PASS! response:%o", res);
	
	        res = res.body;
	        console.log("successful res:%o", res);
	        console.log("code:" + res.code + ",typeof:" + (0, _typeof3.default)(res.code));
	        var res_data = res.data;
	        console.log("res_data:%o", res_data);
	        if (res.code === 0) {
	          _this.openid = res_data.openid;
	          _this.coins = res_data.coin;
	          _this.name = res_data.name;
	          _this.portrait = res_data.portrait;
	          _this.token = res_data.token;
	
	          console.log("openid:%s, token%s, coins:%s, name:%s, portrait:%s ", _this.openid, _this.token, _this.coins, _this.name, _this.portrait);
	          _auth2.default.setOpenid(_this.openid);
	          _auth2.default.setCoins(_this.coins);
	          _auth2.default.setName(_this.name);
	          _auth2.default.setPortrait(_this.portrait);
	          _auth2.default.setToken(_this.token);
	          _this.reqWxJSSign();
	        }
	        var as = "loginUrl! openid:" + _this.openid + ", token:" + _this.token + ", coins:" + _this.coins + ", name:" + _this.name + ", portrait:" + _this.portrait;
	        console.log(as);
	      }, function (response) {
	        var as = "loginUrl fail!!! response:" + response;
	        console.error(as);
	      });
	    },
	    regWxPay: function regWxPay() {
	      console.log("regWxPay");
	      console.log("wxp_nonceStr:%s, wxp_package:%s, wxp_paySign:%s, wxp_signType:%s, wxp_timeStamp:%s", this.wxp_nonceStr, this.wxp_package, this.wxp_paySign, this.wxp_signType, this.wxp_timeStamp);
	      _weixinJsSdk2.default.chooseWXPay({
	        debug: false,
	        timestamp: this.wxp_timeStamp,
	        nonceStr: this.wxp_nonceStr,
	        package: this.wxp_package,
	        signType: this.wxp_signType,
	        paySign: this.wxp_paySign,
	        success: function success(res) {
	          console.log("pay successful!" + res);
	        },
	        error: function error(json) {
	          console.error("pay failed:" + json);
	        }
	      });
	    },
	    reqWxPaySign: function reqWxPaySign() {
	      var _this2 = this;
	
	      var url = this.reqWxPaySignUrl;
	      var para = {
	        'openid': this.openid, 'token': this.token, 'money': 100
	      };
	      console.log("reqWxPaySign url:%s", url);
	      this.$http.post(url, para).then(function (response) {
	        console.log("PASS! response:%o", response);
	        console.log("status%s", response.status);
	        console.log("statusText:%s", response.statusText);
	        console.log("Expires: %s", response.headers.get('Expires'));
	        console.log("body: %o", response.body);
	        var dl = response.body.data;
	        _this2.wxp_nonceStr = dl.nonceStr, _this2.wxp_package = dl.package, _this2.wxp_paySign = dl.paySign, _this2.wxp_signType = dl.signType, _this2.wxp_timeStamp = dl.timeStamp, console.log("wxp_nonceStr:%s, wxp_package:%s, wxp_paySign:%s, wxp_signType:%s, wxp_timeStamp:%s", _this2.wxp_nonceStr, _this2.wxp_package, _this2.wxp_paySign, _this2.wxp_signType, _this2.wxp_timeStamp);
	
	        if (_this2.autopay === '1') {
	          console.log("start autopay");
	          _this2.regWxPay();
	        }
	      }, function (response) {
	        console.error("FAIL!!! response:%o", response);
	      });
	    },
	    wxPayReg: function wxPayReg(money) {
	      var _this3 = this;
	
	      console.log("wxPayReg: openid:%s, token:%s, money:%s", this.openid, this.token, money);
	      var url = "http://alphago.chemucao.cn/real/api/index.php/wxpay/jsapi";
	      var req_data = { openid: this.openid, token: this.token, money: money };
	      console.log("wxPayReg url:%s, req_data:%o", url, req_data);
	      this.$http.post(url, req_data).then(function (data) {
	        data = data.body;
	        console.log("wxPayReg successful data:%o", data);
	        console.log("code:" + data.code + ",typeof:" + (0, _typeof3.default)(data.code));
	        var res_data = data.data;
	        console.log("res_data:%o", res_data);
	        if (data.code === 0) {
	          console.log("res_data:%o", res_data);
	          _this3.wx_appId = res_data.appId;
	          _this3.wxp_nonceStr = res_data.nonceStr;
	          _this3.wxp_timeStamp = res_data.timeStamp;
	          _this3.wxp_package = res_data.package;
	          _this3.wxp_paySign = res_data.paySign;
	          _this3.wxp_signType = res_data.signType;
	
	          console.log("appId:%s, nonceStr:%s, timestamp:%s, package:%s, paySign:%s, signType:%s", _this3.wx_appId, _this3.wxp_nonceStr, _this3.wxp_timeStamp, _this3.wxp_package, _this3.wxp_paySign, _this3.wxp_signType);
	          var msg = "appId" + _this3.wx_appId + "nonceStr:" + _this3.wxp_nonceStr + ", timestamp:" + _this3.wxp_timeStamp + ", package:" + _this3.wxp_package + ", paySign:" + _this3.wxp_paySign + ", signType:" + _this3.wxp_signType;
	          console.log(msg);
	        }
	      }, function (response) {
	        var msg = "wxPayReg failed!!!" + response;
	        console.error(msg);
	      });
	    },
	    wxpaySubmit: function wxpaySubmit() {
	      console.log("wxpaySubmit pay start");
	      this.regWxPay();
	      console.log("wxpaySubmit pay done");
	      return;
	      console.log("wxpaySubmit pay overload");
	
	      var msg = "nonceStr:" + this.wxp_nonceStr + ", timestamp:" + this.wxp_timeStamp + ", package:" + this.wxp_package + ", paySign:" + this.wxp_paySign + ", signType:" + this.wxp_signType;
	
	      console.log("nonceStr;%s, timestamp:%s, package:%s, paySign:%s, signType:%s", this.wxp_nonceStr, this.wxp_timeStamp, this.wxp_package, this.wxp_paySign, this.wxp_signType);
	      _weixinJsSdk2.default.chooseWXPay({
	        timestamp: this.wxp_timeStamp,
	        nonceStr: this.wxp_nonceStr,
	        package: this.wxp_package,
	        signType: this.wxp_paySign,
	        paySign: this.wxp_signType,
	        success: function success(res) {
	          var msg = "pay pass!" + res;
	          alert(msg);
	        },
	        error: function error(json) {
	          var msg = "pay fail!!!" + json;
	          alert(msg);
	        }
	      });
	    },
	    submit: function submit() {
	      console.log("submit community:%s", this.community);
	      this.reqHouseArea(this.community);
	      _auth2.default.setCm(this.community);
	    },
	    regWxJsApi: function regWxJsApi() {
	      console.log("regWxJsApi");
	      console.log("wx_appId:%s, wx_timestamp:%d, wx_nonceStr:%s, wx_signature:%s", this.wx_appId, this.wx_timestamp, this.wx_nonceStr, this.wx_signature);
	      _weixinJsSdk2.default.config({
	        debug: false,
	        appId: this.wx_appId,
	        timestamp: this.wx_timestamp,
	        nonceStr: this.wx_nonceStr,
	        signature: this.wx_signature,
	        jsApiList: ['getLocation', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone', 'chooseWXPay'],
	        success: function success(res) {
	          console.log("config successful!" + res);
	        },
	        error: function error(json) {
	          console.error("config failed:" + json);
	        }
	      });
	      this.reqWxPaySign();
	
	      _weixinJsSdk2.default.ready(function () {
	        console.log("wx.ready!");
	        _weixinJsSdk2.default.checkJsApi({
	          jsApiList: ['getLocation', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone', 'chooseWXPay'],
	          success: function success(res) {
	            console.log((0, _stringify2.default)(res));
	          },
	          error: function error(json) {
	            var msg = "config failed:" + json;
	            alert(msg);
	          }
	        });
	        _weixinJsSdk2.default.getLocation({
	          success: function success(res) {
	            console.log("res:%o", res);
	
	            var res_data = res;
	            console.log(res_data);
	            var latitude = res_data.latitude;
	            var longitude = res_data.longitude;
	            var speed = res_data.speed;
	            var accuracy = res_data.accuracy;
	
	            console.log("latitude:%s, longitude:%s, speed:%s, accuracy:%s", latitude, longitude, speed, accuracy);
	            _auth2.default.setLat(latitude);
	            _auth2.default.setLongt(longitude);
	          },
	          cancel: function cancel(res) {
	            alert('用户拒绝授权获取地理位置');
	          }
	        });
	      });
	    },
	    reqWxJSSign: function reqWxJSSign() {
	      var _this4 = this;
	
	      var local_url = location.href.split('#')[0];
	      console.log("reqWxJSSign local_url:%s", local_url);
	      var url = this.reqWxJSSignUrl;
	
	      console.log("reqWxJSSign url:%s", url);
	      var parameter = { 'openid': this.openid, 'token': this.token, 'url': local_url };
	      console.log("reqWxJSSign parameter:%o", parameter);
	      this.$http.post(url, parameter).then(function (response) {
	        console.log("reqWxJSSign body: %o", response.body);
	        var dl = response.body.data;
	        console.log("reqWxJSSign dl:" + dl);
	        _this4.wx_appId = dl.appId;
	        _this4.wx_timestamp = dl.timestamp;
	        _this4.wx_nonceStr = dl.nonceStr;
	        _this4.wx_signature = dl.signature;
	        console.log("reqWxJSSign wx_appId:%s, wx_timestamp:%d, wx_nonceStr:%s, wx_signature:%s", _this4.wx_appId, _this4.wx_timestamp, _this4.wx_nonceStr, _this4.wx_signature);
	
	        _this4.regWxJsApi();
	
	        _this4.show1 = false;
	      }, function (response) {
	        console.error("reqWxJSSign FAIL!!! response:%o", response);
	      });
	    }
	  },
	  watch: {
	    '$route': function $route(to, from) {
	      var toDepth = to.path.split('/').length;
	      var fromDepth = from.path.split('/').length;
	      this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-lef';
	    }
	  } };

/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(83);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Main = __webpack_require__(84);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _weixinJsSdk = __webpack_require__(85);
	
	var _weixinJsSdk2 = _interopRequireDefault(_weixinJsSdk);
	
	var _auth = __webpack_require__(40);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _vuex = __webpack_require__(41);
	
	var _index = __webpack_require__(125);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(62);
	
	var _index4 = _interopRequireDefault(_index3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      value: '请输入小区名（查询一次仅需1钢蹦）',
	      subtitleMsg: '你可能感兴趣的小区',
	      lists: [],
	      token: '',
	      openid: '',
	      reqNearbyUrl: null,
	      reqHouseAreaUrl: null,
	      reqType: null,
	      community: ''
	    };
	  },
	
	  computed: (0, _vuex.mapState)({
	    pageType: function pageType(state) {
	      return state.jw.type;
	    } }),
	  mounted: function mounted() {
	    console.debug(">>> mounted, query:%o", this.$route.query);
	    if (this.$route.query.type != null) {
	      this.reqType = this.$route.query.type;
	    } else {
	      this.reqType = '0';
	    }
	  },
	  created: function created() {
	    console.debug(">>> home body state jw:%o", this.$store.state.jw);
	    console.log("created currentRoute:%o", this.$root.currentRoute);
	    console.log("route.query.type:%s", this.$route.query.type);
	    if (this.$route.query.type === '1') {
	      console.debug("bussiness area");
	      this.reqNearbyUrl = "http://alphago.chemucao.cn/real/api/index.php/bizcycle/nearby";
	      this.subtitleMsg = '你可能感兴趣的商圈';
	      this.value = '请输入商圈名（查询一次仅需1钢蹦）';
	      this.reqType = this.$route.query.type;
	    } else if (this.$route.query.type === '2') {
	      console.debug("district area");
	      this.reqNearbyUrl = "http://alphago.chemucao.cn/real/api/index.php/district/nearby";
	      this.subtitleMsg = '你可能感兴趣的区县';
	      this.value = '请输入区县名（查询一次仅需1钢蹦）';
	      this.reqType = this.$route.query.type;
	    } else if (this.$route.query.type === '3') {
	      console.debug("city area");
	      this.reqNearbyUrl = "http://alphago.chemucao.cn/real/api/index.php/city/deal";
	      this.subtitleMsg = '你可能感兴趣的城市';
	      this.value = '请输入城市名（查询一次仅需1钢蹦）';
	      this.reqType = this.$route.query.type;
	      this.updateType(this.reqType);
	      console.debug(">>> home body after state type:%s", this.pageType);
	      this.community = '北京';
	      _auth2.default.setCm(this.community);
	      this.$router.push({ path: '/detail', query: { type: this.reqType } });
	    } else {
	      console.debug("nearby area");
	      this.reqNearbyUrl = "http://alphago.chemucao.cn/real/api/index.php/community/nearby";
	      this.reqType = 0;
	    }
	    this.updateType(this.reqType);
	    console.debug(">>> home body after state type:%s", this.pageType);
	    var lat = _auth2.default.getLat();
	    var longt = _auth2.default.getLongt();
	    this.openid = _auth2.default.getOpenid();
	    this.token = _auth2.default.getToken();
	    this.reqNearby(this.openid, this.token, lat, longt);
	  },
	
	  methods: (0, _extends3.default)({}, (0, _vuex.mapMutations)(['updateType']), {
	    reqNearby: function reqNearby(openid, token, latitude, longitude) {
	      var _this = this;
	
	      console.log("reqNearby: openid:%s, token:%s, latitude:%s, longitude:%s", openid, token, latitude, longitude);
	
	      var url = this.reqNearbyUrl;
	      var req_data = { openid: openid, token: token, latitude: latitude, longitude: longitude };
	      console.log("url:%s, req_data:%o", url, req_data);
	      this.$http.post(url, req_data).then(function (data) {
	        data = data.body;
	        console.log("successful data:%o", data);
	
	        var res_data = data.data.nearby;
	        console.log("res_data:%o", res_data);
	        if (data.code === 0) {
	          var od = [];
	
	          for (var p in res_data) {
	            od.push(res_data[p]["name"]);
	          }
	
	          _this.lists = od;
	          console.log("list:%o", _this.lists);
	        }
	      }, function (response) {
	        var msg = "wxPayReg failed!!!" + response;
	        console.error(msg);
	        alert(msg);
	      });
	    },
	    submit: function submit() {
	      this.openid = _auth2.default.getOpenid();
	      this.token = _auth2.default.getToken();
	      console.log("openid:%s, token:%s, community:%s", this.openid, this.token, this.community);
	      this.reqHouseArea(this.openid, this.token, this.community);
	      _auth2.default.setCm(this.community);
	    },
	    updateCm: function updateCm(cm) {
	      console.log("update cm:%s", cm);
	      _auth2.default.setCm(cm);
	    },
	    reqHouseArea: function reqHouseArea(openid, token, community) {
	      var _this2 = this;
	
	      console.log("openid:%s, token:%s, community:%s", openid, token, community);
	
	      var req_data = null;
	      console.log("route.query.type:%s", this.$route.query.type);
	      if (this.$route.query.type === '1') {
	        console.debug("bussiness area");
	        this.reqHouseAreaUrl = "http://alphago.chemucao.cn/real/api/index.php/bizcycle/deal";
	        req_data = { openid: openid, token: token, bizcycle: community };
	      } else if (this.$route.query.type === '2') {
	        console.debug("district area");
	        this.reqHouseAreaUrl = "http://alphago.chemucao.cn/real/api/index.php/district/deal";
	        req_data = { openid: openid, token: token, district: community };
	      } else if (this.$route.query.type === '3') {
	        console.debug("city area");
	        this.reqHouseAreaUrl = "http://alphago.chemucao.cn/real/api/index.php/city/deal";
	        req_data = { openid: openid, token: token, city: community };
	      } else {
	        console.debug("nearby area");
	        this.reqHouseAreaUrl = "http://alphago.chemucao.cn/real/api/index.php/community/deal";
	        req_data = { openid: openid, token: token, community: community };
	      }
	
	      var url = this.reqHouseAreaUrl;
	      console.log("reqHouseArea url:%s", url);
	      this.$http.post(url, req_data).then(function (response) {
	        console.log("PASS! response:%o", response);
	        console.log("data:%o", response.body.data);
	        if (response.status === 200 && response.body.data.guess != null) {
	          var datalist = response.body.data.guess;
	
	          var od = [];
	
	          for (var p in datalist) {
	            od.push(datalist[p]["name"]);
	          }
	          _this2.lists = od;
	        }
	      }, function (response) {
	        console.error("FAIL!!! response:%o", response);
	      });
	    }
	  }),
	  components: {
	    Search: _index2.default,
	    Divider: _index4.default,
	    MainLayout: _Main2.default
	  }
	};

/***/ },
/* 634 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  components: {}
	};

/***/ },
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ }
]);


// WEBPACK FOOTER //
// static/js/app.d7b046d6b0c834042832.js